/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import {FC, useRef, useState} from 'react'
import {
  generateAddress,
  configCategoryMap,
  toAbsoluteUrl,
} from '../../../../../../../_metronic/helpers'
import {User} from '../../core/_models'
import {ViewImageModal} from '../../../../../../../app/modules/apps/data-administration/data-admininstration-list/table/columns/ViewImageModal'
import ImageLightBox from '../../../../../../../_metronic/helpers/components/ImageLightBox'
import {UserTableModal} from './UserTableModal'
import {UserTableModal2} from './UserTableModal2'
import {RecyclerAddress} from './RecyclerAddress'
import {RecyclerBankDetails} from './RecyclerBankDetails'
import {KycDetails} from './KycDetails'
import {AggrigatorKyc} from './AggrigatorKyc'
import {ApprovedListingDetails} from './ApprovedListingDetails'
import {OrderMngPopUp} from './OrderMngPopUp'
import {PurchaseRequestPopup} from './PurchaseRequestPopup'
import {ApprovedListingDetailsMain} from './ApprovedListingDetailsMain'
import {OrderMngAssigned} from './OrderMngAssigned'
import {TransportPopUp} from './TransportPopUp'
import {TextilePopUp} from './TextilePopUp'
import {AssignVehicleRequirementPopUp} from './AssignVehicleRequirementPop'
import {DOpopUp} from './DOpopUp'
import {AssignVehicleMaterialPopUp} from './AssignVehicleMaterialPopUp'

import {ReconiliAddress} from './ReconiliAddress'
import {ReconcillationGRNINFOPopUp} from './ReconcillationGRNINFOPopUp'
import {ReconcillationMATERIALPopUp} from './ReconcillationMATERIALPopUp'
import {QualityAssessmentMaterialPopUp} from './QualityAssessmentMaterialPopUp'
import {QualityASSAddPopUp} from './QualityASSAddPopUp'
import {PurchseOrderRecyclerAddress} from './PurchseOrderRecyclerAddress'
import {VerifiedListingDetails} from './VerifiedListingDetails'
import {PaymentInfoPopUp} from './PaymentInfoPopUp'
import {DeliveryOrderAddress} from './DeliveryOrderAddress'

import {KTIcon} from '../../../../../../../_metronic/helpers'

import {useAuth} from '../../../../../auth'
import {useLocation, useNavigate} from 'react-router-dom'
import {TextileSaleOrderPopUp} from './TextileSaleOrderPopUp'
import {ViewUserLots} from './ViewUserLots'

type Props = {
  user: any
  showImage?: boolean
  mapData?: string
  subValue?: string
  valueLeft?: string
  valueRight?: string
  showImageOnly?: boolean
  ref?: any
  itemIdForUpdate?: any
}

interface ImageModalState {
  show: boolean
  clicked: string
  data?: any
}

const UserInfoCell: FC<Props> = ({
  user,
  showImageOnly = false,
  showImage = false,
  mapData = '',
  subValue = '',
  valueLeft = '',
  valueRight = '',
  ref,
  itemIdForUpdate,
}) => {
  const lightBoxRef = useRef<any>(null)
  const [showImageModal, setshowImageModal] = useState({
    show: false,
    clicked: '',
    data: null,
  })
  const [showPaymentDetails, setShowPaymentDetails] = useState(false)
  const [showUserTable, setShowUserTable] = useState(false)
  const [showLotsTable, setShowLotsTable] = useState(false)
  const [showPaymentDropdown, setShowPaymentDropdown] = useState(false)
  const [detailsDropdown, setDetailsDropdown] = useState(false)

  const {currentUser} = useAuth()
  const navigate = useNavigate()

  // const { currentUser } = useAuth();
  const location = useLocation()

  // console.log("currentUser", currentUser)

  const formatDateForInput = (timestamp: number) => {
    if (!timestamp || isNaN(timestamp)) return ''
    try {
      const date = new Date(timestamp)
      if (isNaN(date.getTime())) return ''

      const month = date.getMonth() + 1 // No padding with zeros
      const day = date.getDate() // No padding with zeros
      const year = date.getFullYear()
      return `${day}/${month}/${year}`
    } catch {
      return ''
    }
  }

  const accessNestedProperty = (obj, path) => {
    return path.split('[').reduce((acc, key) => {
      return acc && acc[key.replace(']', '')]
    }, obj)
  }
  const configMapData = configCategoryMap
  const handleClick = (image) => {
    console.log({image, lightBoxRef})
    lightBoxRef?.current?.open(image, itemIdForUpdate)
  }

  if (showImageModal.show) {
    return (
      <ViewImageModal
        close={() =>
          setshowImageModal({
            show: false,
            clicked: '',
            data: null,
          })
        }
        images={
          showImageModal.clicked === 'vehicleImages'
            ? user?.pickupInfo?.vehicleDetails?.vehicleImages
            : showImageModal.clicked === 'debrisImagePathList'
            ? user.debrisImagePathList
            : user.images
        }
        name={showImageModal.clicked}
      />
    )
  }

  const returnData = () => {
    if (mapData.includes('[')) return clipText(accessNestedProperty(user, mapData), 30)
    let displayStatus = ''
    switch (mapData) {
      case 'facilityType':
        return user?.facilityType?.toUpperCase()
      case 'categoryMap':
        return <div>{configMapData[user.categoryId] || ''}</div>
      case 'format':
        return user.companyDetails.format || 'OWN'

      case 'companyDetailswithpic':
        const profileImage = user?.personalDetails?.profileImage
        const companyName = user?.companyDetails?.name || ''
        const categoryField = user?.categoryField || ''

        // Get initials from company name
        const getInitials = (name: string) => {
          if (!name) return '?'
          const words = name.trim().split(' ')
          if (words.length >= 2) {
            return (words[0][0] + words[1][0]).toUpperCase()
          }
          return name.slice(0, 2).toUpperCase()
        }

        // Limit name to 15 characters
        const truncatedName =
          companyName.length > 15 ? companyName.slice(0, 15) + '...' : companyName

        const initials = getInitials(companyName)

        return (
          <div style={{display: 'flex', alignItems: 'center', gap: '12px'}}>
            <div
              style={{
                position: 'relative',
                width: '45px',
                height: '45px',
              }}
            >
              {profileImage ? (
                <img
                  src={profileImage}
                  alt='Profile'
                  style={{
                    width: '45px',
                    height: '45px',
                    borderRadius: '50%',
                    objectFit: 'cover',
                  }}
                />
              ) : (
                <div
                  style={{
                    width: '45px',
                    height: '45px',
                    borderRadius: '50%',
                    backgroundColor: '#4f46e5',
                    color: '#ffffff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '16px',
                    fontWeight: 600,
                  }}
                >
                  {initials}
                </div>
              )}

              {/* Green verification tick */}
              <div
                style={{
                  position: 'absolute',
                  bottom: '-2px',
                  right: '-2px',
                  width: '16px',
                  height: '16px',
                  borderRadius: '50%',
                  backgroundColor: user?.physicalInspection === 'YES' ? '#22c55e' : '#dc3545',
                  border: '2px solid #ffffff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#ffffff',
                  fontSize: '10px',
                  fontWeight: 700,
                  lineHeight: 1,
                }}
              >
                {user?.physicalInspection === 'YES' ? '✓' : 'x'}
              </div>
            </div>
            <div className='d-flex flex-column align-items-start'>
              <span title={companyName}>{truncatedName}</span>
              {categoryField && (
                <span
                  style={{
                    backgroundColor: '#dfffea',
                    color: '#1fc95f',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    fontSize: '12px',
                    fontWeight: 'bold',
                    display: 'inline-block',
                  }}
                >
                  {categoryField}
                </span>
              )}
            </div>
          </div>
        )

      // case 'personalDetail':
      //   return (
      //     <div>
      //       <div>{user.personalDetails?.mobile}</div>
      //       <div className='text-muted fw-bold text-muted d-block fs-7'>
      //         {user.personalDetails?.email}
      //       </div>
      //     </div>
      //   )

      case 'tusermng':
        const tusermngProfileImage = user?.personalDetails?.profileImage
        const tusermngUserName = user?.personalDetails?.name || ''

        // Get initials from user name
        const getTusermngInitials = (name: string) => {
          if (!name) return '?'
          const words = name.trim().split(' ')
          if (words.length >= 2) {
            return (words[0][0] + words[1][0]).toUpperCase()
          }
          return name.slice(0, 2).toUpperCase()
        }

        // Limit name to 15 characters
        const tusermngTruncatedName =
          tusermngUserName.length > 15 ? tusermngUserName.slice(0, 15) + '...' : tusermngUserName
        const tusermngInitials = getTusermngInitials(tusermngUserName)

        return (
          <div style={{display: 'flex', alignItems: 'center', gap: '12px'}}>
            {tusermngProfileImage ? (
              <img
                src={tusermngProfileImage}
                alt='Profile'
                style={{
                  width: '45px',
                  height: '45px',
                  borderRadius: '50%',
                  objectFit: 'cover',
                }}
              />
            ) : (
              <div
                style={{
                  width: '45px',
                  height: '45px',
                  borderRadius: '50%',
                  backgroundColor: '#4f46e5',
                  color: '#ffffff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '16px',
                  fontWeight: 600,
                }}
              >
                {tusermngInitials}
              </div>
            )}
            <span title={tusermngUserName}>{tusermngTruncatedName}</span>
          </div>
        )

      case 'personalDetail':
        return (
          <div className='d-flex align-items-center'>
            {/* Image Container */}
            <div
              className='symbol symbol-circle overflow-hidden me-3'
              style={{width: '40px', height: '40px'}}
            >
              <img
                src={user?.kycDocument?.[0]?.docUrl}
                alt='User KYC'
                className='w-100 h-100 object-cover'
              />
            </div>

            {/* Right Side Content */}
            <div>
              <div>{user?.personalDetails?.name}</div>
              <div className='text-muted fw-bold text-muted d-block fs-7'>
                {user?.personalDetails?.email}
              </div>
            </div>
          </div>
        )

      case 'iconPr':
        return (
          <div className='symbol symbol-circle'>
            {user?.icon ? (
              <img
                onClick={() => handleClick(user?.icon || toAbsoluteUrl(`/media/avatars/blank.png`))}
                src={user?.icon || ''}
                alt={user.name}
              />
            ) : (
              ''
            )}
          </div>
        )

      case 'contactDetail':
        return (
          <div>
            <div>{user.companyDetails?.mobile}</div>
            <div className='text-muted fw-semibold text-muted d-block fs-7'>
              {user.companyDetails?.email}
            </div>
          </div>
        )
      case 'icon':
        return (
          <div className='symbol symbol-circle'>
            {user?.icon ? (
              <img
                onClick={() => handleClick(user?.icon || toAbsoluteUrl(`/media/avatars/blank.png`))}
                src={user?.icon || ''}
                alt={user.name}
              />
            ) : (
              ''
            )}
          </div>
        )
      case 'categoryIcon':
        return (
          <div className='symbol symbol-circle swymbol-50px overflow-hidden me-3'>
            <div className='symbol-label'>
              <img
                src={`${user?.orderDetails?.[0]?.categoryIcon || ''}`}
                alt={user.name}
                className='w-100 bg-[#156467]'
              />
            </div>
          </div>
        )
      case 'categoryName':
        return user?.orderDetails?.[0]?.categoryName || user?.categoryName || ''
      case 'quantityDeposit':
        const totalQuantity =
          user?.orderDetails?.[0]?.items?.reduce((acc, curr) => {
            return acc + curr.quantity
          }, 0) || 0
        return <span className='text-primary fs-7 fw-bold'>{totalQuantity?.toFixed(2)} kg</span>

      // case 'pickup_quantity':
      // case 'pickup_quantity_item':
      //   return user?.orderDetails?.[0].items?.map((x: any, ind: number) => (
      //     <div key={ind + 1 + ''}  >
      //       {mapData === 'pickup_quantity_item' ? x.itemName : x.quantity?.toFixed(2)} Kg
      //     </div>
      //   ))

      case 'try': {
        return (
          <>
            <div
              className='cursor-pointer text-primary hover:text-primary-dark'
              onClick={() => setShowUserTable(true)}
            >
              Click to view
            </div>

            <UserTableModal
              show={showUserTable}
              user={user}
              onClose={() => setShowUserTable(false)}
            />
          </>
        )
      }
      case 'viewLots': {
        return (
          <>
            <div
              className='cursor-pointer text-primary hover:text-primary-dark'
              onClick={() => setShowLotsTable(true)}
            >
              Click to view
            </div>

            <ViewUserLots
              show={showLotsTable}
              user={user}
              onClose={() => setShowLotsTable(false)}
            />
          </>
        )
      }

      case 'paymentTry': {
        return (
          <>
            <div
              className='cursor-pointer text-primary hover:text-primary-dark'
              onClick={() => setShowPaymentDetails(true)}
            >
              Click to view
            </div>

            <UserTableModal2
              show={showPaymentDetails}
              user={user}
              onClose={() => setShowPaymentDetails(false)}
            />
          </>
        )
      }

      case 'ymINput':
        return user?.inMaterials?.map((m: any) => m.name).join(', ')
      case 'ymYield':
        return Object.values(user?.itemYieldDetail || {})
          .map((val: any) => val.itemName)
          .join(', ')
      case 'ymYieldv':
        return Object.values(user?.itemYieldDetail || {})
          .map((val: any) => val.yield)
          .join(', ')

      // case 'paymentTry': {
      //   const isPaymentDataAvailable = user?.amountPaid || user?.utrNumber || user?.poCopy;
      //   return (
      //     <>
      //       <div
      //         className={`cursor-pointer text-primary hover:text-primary-dark ${!isPaymentDataAvailable ? 'opacity-50 pointer-events-none' : ''}`}
      //         onClick={() => isPaymentDataAvailable && setShowPaymentDetails(true)}
      //       >
      //         Click to view
      //       </div>

      //       <UserTableModal2
      //         show={showPaymentDetails}
      //         user={user}
      //         onClose={() => setShowPaymentDetails(false)}
      //       />
      //     </>
      //   );
      // }

      case 'pickup_quantity':
      case 'pickup_quantity_item':
        return user?.orderDetails?.[0].items?.map((x: any, ind: number) => (
          <div key={ind + 1 + ''}>
            {mapData === 'pickup_quantity_item' ? (
              x.itemName
            ) : (
              <span className='text-primary fs-7 fw-bold'>{x.quantity?.toFixed(2)} Kg</span>
            )}
          </div>
        ))

      // case "ReportsAmount":
      //   return "hello"
      // case "ReportsRemainingAmount":
      //   return "hello"

      case 'proofEstablishment':
      case 'proofOfIdentity':
      case 'proofOfFacility':
      case 'bussinessImage':
      case 'personalImage':
        return (
          <div className='symbol symbol-circle swymbol-50px overflow-hidden me-3'>
            <div className='symbol-label'>
              <img
                onClick={() =>
                  handleClick(
                    user?.kycDocument?.[mapData === 'bussinessImage' ? 0 : 1]?.docUrl ||
                      user?.kycDocument?.[mapData === 'bussinessImage' ? 0 : 1] ||
                      '' ||
                      toAbsoluteUrl(`/media/avatars/blank.png`)
                  )
                }
                src={`${
                  user?.kycDocument?.[mapData === 'bussinessImage' ? 0 : 1]?.docUrl ||
                  user?.kycDocument?.[mapData === 'bussinessImage' ? 0 : 1] ||
                  ''
                }`}
                alt={user.name}
                className='w-100'
              />
            </div>
          </div>
        )

      case 'centreInfoName':
        return clipText(user?.centreInfo?.name, 13, '...')

      case 'customerInfoName':
        return clipText(user?.customerInfo?.name, 13, '...')
      case 'pickupointNameAggre':
        return clipText(user?.pickupointName, 13, '...')
      case 'companyDetailsName':
        return clipText(user?.companyDetails?.name, 13, '...')
      case 'personalDetailName':
        return (
          <div>
            <div>{clipText(user?.personalDetails?.mobile, 13, '...')}</div>
            <div className='text-muted fw-bold text-muted d-block fs-7'>
              {clipText(user?.personalDetails?.email, 13, '...')}
            </div>
          </div>
        )
      case 'addressNew':
        // return generateAddress(user.address || user.pickupInfo?.address)

        const addressConcat2 = generateAddress(
          user.address || user.pickupInfo?.address || user.dropOffPointInfo?.address
        )
        return (
          <div data-bs-toggle='tooltip' title={addressConcat2}>
            {clipText(addressConcat2, 13)}
          </div>
        )
      case 'bankDetailsBankName':
        return clipText(user?.bankDetails?.bankName, 13, '...')
      case 'bankDetailsAccountName':
        return clipText(user?.bankDetails?.accountName, 13, '...')
      case 'personalDetailsNameAgg':
        return clipText(user?.personalDetails?.name, 13, '...')
      case 'streetShort':
        return clipText(user?.address?.street, 13, '...')
      case 'bankDetailsBankName':
        return clipText(user?.bankDetails?.bankName, 13, '...')
      case 'nameAgg':
        return clipText(user?.personalDetails?.name, 13, '...')
      case 'addressCity':
        return clipText(user?.address?.city, 13, '...')
      case 'proofOfIdentityPic':
        // Find the object with docType === 'POE' in the kycDocuments array
        const proofOfIdentityDoc = user?.kycDocument?.find((doc) => doc?.docType === 'POE')

        return (
          <div className='symbol symbol-circle swymbol-50px overflow-hidden me-3'>
            <div className='symbol-label'>
              <img
                onClick={() =>
                  handleClick(
                    proofOfIdentityDoc?.docUrl || '' || toAbsoluteUrl(`/media/avatars/blank.png`)
                  )
                }
                src={proofOfIdentityDoc?.docUrl || toAbsoluteUrl(`/media/avatars/blank.png`)}
                alt={user.name}
                className='w-100'
              />
            </div>
          </div>
        )

      case 'roleNameLogic':
        // Map the enum value to display name
        const roleNameMap = {
          ADMIN_CXO: 'Admin/CXO',
          REGIONAL_MANAGER: 'Regional Manager',
          FINANCE_MANAGER: 'Finance Manager',
          LOGISTICS: 'Logistics',
          PURCHASE_HEAD: 'Purchase Head',
          PURCHASE_MANAGER: 'Purchase Manager',
          SALES_HEAD: 'Sales Head',
          SALES_MANAGER: 'Sales Manager',
        }

        // Return the display name if found, otherwise return the original enum
        return roleNameMap[user.roleName] || user.roleName

      case 'userRoleLogic':
        // Map enum values to display names
        const roleNameMap2 = {
          ADMIN_CXO: 'Admin/CXO',
          REGIONAL_MANAGER: 'Regional Manager',
          FINANCE_MANAGER: 'Finance Manager',
          LOGISTICS: 'Logistics',
          PURCHASE_HEAD: 'Purchase Head',
          PURCHASE_MANAGER: 'Purchase Manager',
          SALES_HEAD: 'Sales Head',
          SALES_MANAGER: 'Sales Manager',
        }

        // Return the display name if found, otherwise return the original enum
        return roleNameMap2[user.role.name] || user.role.name

      case 'priceTag':
        return user?.price

      case 'catSpO':
        return user?.dispatchOrderDetail?.[0]?.categoryName
      case 'itemSpO':
        return user?.dispatchOrderDetail?.[0]?.items?.[0]?.itemName
      case 'qtySpO':
        return user?.dispatchOrderDetail?.[0]?.items?.[0]?.quantity
      case 'catFs':
        return user?.orderDetail?.[0]?.categoryName
      case 'itemFs':
        return user?.orderDetail?.[0]?.items?.[0]?.itemName
      case 'QtyFs':
        // return user?.orderDetail?.[0]?.items?.[0]?.quantity
        return user?.dispatchOrderDetail?.[0]?.items?.[0]?.quantity
      case 'CatPoR':
        return user?.confirmedOrderDetails?.[0]?.categoryName
      case 'ItemPoR':
        return user?.confirmedOrderDetails?.[0]?.items?.[0]?.itemName

      case 'poRecLoginC':
        return user?.confirmedOrderDetails?.[0]?.categoryName
      case 'poRecLogini':
        return user?.confirmedOrderDetails?.[0]?.items?.[0]?.itemName

      case 'Region':
        return user?.address?.[0]?.state

      // case "pickupPointStaffsw":
      //   return (
      //     <span style={{ color: "#5ac853" }}>
      //       {user?.pickupPoints?.[0]}
      //     </span>
      //   )

      case 'pickupPointStaffsw':
        return (
          <>
            {user?.pickupPoints && user.pickupPoints.length > 0 ? (
              user.pickupPoints.map((pickupPoint, index) => (
                <span key={index} style={{color: '#5ac853', display: 'block'}}>
                  {pickupPoint}
                </span>
              ))
            ) : (
              <span style={{color: '#5ac853'}}></span>
            )}
          </>
        )

      case 'companyNamepayment':
        const name2 = user.companyName
        return name2 && name2.length > 10 ? name2.substring(0, 10) + '...' : name2

      case 'companyNameChanged':
        return user?.toCentreName

      case 'companyNameR':
        return user?.saleOrderDetail.companyName
      case 'companyNameR2':
        return user?.recyclerDetails.name
      case 'logisStreet':
        return user?.address?.[0]?.street
      case 'logisCity':
        return user?.address?.[0]?.city
      case 'logisZip':
        return user?.address?.[0]?.zipCode
      case 'QTY':
        return (
          <div style={{display: 'flex', alignItems: 'flex-start', gap: '10px'}}>
            <div
              style={{
                width: '14px',
                height: '14px',
                borderRadius: '50%',
                backgroundColor: '#e8f5e9',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
              }}
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='12'
                height='12'
                viewBox='0 0 24 24'
                fill='none'
                stroke='#00695c'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
              >
                <line x1='12' y1='20' x2='12' y2='10' />
                <line x1='18' y1='20' x2='18' y2='4' />
                <line x1='6' y1='20' x2='6' y2='16' />
              </svg>
            </div>

            <span>{user?.orderDetail[0]?.items[0]?.quantity}</span>
          </div>
        )
      case 'Available':
        return user?.orderDetail[0]?.items[0]?.remainingQuantity
      case 'bal':
        return user?.orderDetail[0]?.items[0]?.remainingQuantity
      case 'cate':
        return user?.orderDetail[0]?.items[0]?.itemName
      case 'cate2':
        return user?.orderDetail[0]?.items[0]?.displayName
      case 'grade':
        return user?.orderDetail?.[0]?.items?.[0]?.grade
      case 'grade2':
        return user?.grade
      case 'color':
        return user?.orderDetail[0]?.items[0]?.color
      case 'personalMobile':
        return user?.personalDetails?.mobile

      // case "deliveryDateM":
      //   return user?.confirmedDeliveryDate ? formatDateForInput(user?.confirmedDeliveryDate) : '';

      case 'deliveryDateM':
        const deliveryDate = user?.confirmedDeliveryDate
          ? formatDateForInput(user?.confirmedDeliveryDate)
          : ''
        const isPastDue =
          user?.confirmedDeliveryDate && new Date(user.confirmedDeliveryDate) < new Date()

        return (
          <span
            style={{
              color: isPastDue ? '#ff0000' : 'inherit',
            }}
          >
            {deliveryDate}
          </span>
        )

      case 'ProductImgaetrace':
        return (
          <div style={{display: 'flex', alignItems: 'center'}}>
            {user.productImages?.slice(0, 4).map((img, index) => (
              <img
                key={index}
                src={img.url}
                alt={img.image}
                style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  border: '2px solid white',
                  marginLeft: index === 0 ? '0' : '-12px',
                  objectFit: 'cover',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                  zIndex: user.productImages.length - index,
                }}
              />
            ))}
            {user.productImages?.length > 4 && (
              <div
                style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  border: '2px solid white',
                  marginLeft: '-12px',
                  backgroundColor: '#003b73',
                  color: 'white',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '12px',
                  fontWeight: 'bold',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                }}
              >
                +{user.productImages.length - 4}
              </div>
            )}
          </div>
        )

      case 'skucategoryItem':
        return `${user?.categoryName}, ${user?.itemName}`

      case 'deliveryDateMpurchaseOrder':
        return formatDateForInput(user?.confirmedDeliveryDate)
      case 'item':
        return user?.orderDetail?.[0]?.items?.[0]?.itemName
      case 'price':
        return user?.orderDetail?.[0]?.items?.[0]?.price
      case 'QTYAL':
        return user?.confirmedOrderDetails?.[0]?.items?.[0]?.quantity
      case 'QTYPrice':
        return user?.confirmedOrderDetails?.[0]?.items?.[0]?.price
      case 'cateAl':
        return user?.orderDetail?.[0]?.categoryName
      case 'createdAtPR':
        return user?.createdAt
      case 'deliveryDatepr':
        return formatDateForInput(user?.deliveryDate)
      case 'categoryPurchaseRequest':
        return user?.orderDetail?.[0]?.categoryName
      case 'categoryListedStock':
        return user?.orderDetail?.[0]?.categoryName
      case 'categoryVarifiedListing':
        return user?.orderDetail?.[0]?.categoryName
      case 'categoryIncentive':
        return user?.orderDetail?.[0]?.categoryName
      case 'categoryDeliveryOrder':
        return user?.orderDetail?.[0]?.categoryName
      case 'categoryReconcillation':
        return user?.orderDetail?.[0]?.categoryName
      case 'categoryPayment':
        return user?.orderDetail?.[0]?.categoryName
      case 'categoryPurchaseRequestAdmin':
        return user?.orderDetail?.[0]?.categoryName
      case 'categoryQualityAssessment':
        return user?.orderDetail?.[0]?.categoryName
      case 'categoryOrderManagement':
        return user?.orderDetail?.[0]?.categoryName
      case 'itemListedStock':
        return user?.orderDetail?.[0]?.items?.[0]?.itemName
      case 'purchaseorderRecyclerQty':
        return user?.confirmedOrderDetails?.[0]?.items?.[0]?.quantity

      case 'purchaseorderRecyclerprice':
        return user?.confirmedOrderDetails?.[0]?.items?.[0]?.price
      case 'purchaseorderRecyclerBalance':
        return user?.confirmedOrderDetails?.[0]?.items?.[0]?.remainingQuantity
      case 'remainingQuantityposales':
        return user?.confirmedOrderDetails?.[0]?.items?.[0]?.quantity
      case 'confirmedDeliveryDateORDERm':
        return formatDateForInput(user?.confirmedDeliveryDate)
      case 'orderManagementQty':
        return user?.confirmedOrderDetails?.[0]?.items?.[0]?.quantity
      case 'orderManagementPrice':
        return user?.confirmedOrderDetails?.[0]?.items?.[0]?.price
      case 'DeliveryOrderDispatchDate':
        return formatDateForInput(user?.dispatchDate || user?.deliveryDate)
      case 'deliveryDatePRR':
        return formatDateForInput(user?.deliveryDate)
      case 'VarifiedListingQty':
        return user?.verifiedOrderDetails?.[0]?.items?.[0]?.quantity
      case 'VarifiedListingPrice':
        return user?.verifiedOrderDetails?.[0]?.items?.[0]?.price
      case 'reDetailsDO':
        return user?.recyclerDetails?.name
      case 'reDetailsDOpayment':
        const name = user?.recyclerDetails?.name
        return name && name.length > 10 ? name.substring(0, 10) + '...' : name
      case 'AssignVehicleMaterialRecycler':
        return user?.recyclerDetails?.name
      case 'ReconcillationDate':
        return formatDateForInput(user?.updatedAt)
      case 'ReconcillationRecyclerName':
        return user?.recyclerDetails?.name
      // case "PDueDate":
      //   return formatDateForInput(user?.payment?.paymentDetails?.[0]?.paymentDate)
      case 'pAmount':
        const recyclerPayment = user?.payment?.paymentDetails?.find(
          (payment) => payment.paymentType === 'SUPPLIER'
        )
        return recyclerPayment?.totalAmount || '--'
      case 'RAmount': {
        const recyclerPayment = user?.payment?.paymentDetails?.find(
          (payment) => payment.paymentType === 'RECYCLER'
        )
        return recyclerPayment?.totalAmount || '--'
      }

      // statusRevamp
      case 'status':
        // Render legacy/standard `status` column with special handling
        const getStatusStyleStatus = (status) => {
          switch (status) {
            case 'INVOICE_CREATED':
              return {backgroundColor: '#dfffea', color: '#1fc95f'}
            case 'DISPATCHED':
              return {backgroundColor: '#e9f3ff', color: '#1b84ff'}
            case 'INACTIVE':
            case 'CREATED':
              return {backgroundColor: '#ffeef3', color: '#f8285a'}
            case 'READY_TO_DISPATCH':
            case 'PARTIALLY_FULFILLED':
              return {backgroundColor: '#fff8dd', color: '#f8cb24'}
            case 'VERIFIED':
              return {backgroundColor: '#fff8dd', color: '#f8cb24'}
            case 'ACTIVE':
            case 'COMPLETED':
              return {backgroundColor: '#dfffea', color: '#1fc95f'}
            default:
              return {backgroundColor: '#f5f5f5', color: '#777'}
          }
        }

        const statusStyleStatus = getStatusStyleStatus(user.status)
        const displayStatusStatus =
          user.status === 'PARTIALLY_FULFILLED' ? 'In progress' : user.status

        return (
          <span
            style={{
              ...statusStyleStatus,
              padding: '4px 8px',
              borderRadius: '4px',
              fontSize: '12px',
              fontWeight: 'bold',
              display: 'inline-block',
            }}
          >
            {displayStatusStatus}
          </span>
        )

      case 'statusRevamp':
        // Define styling for different status values
        const getStatusStyle = (status) => {
          switch (status) {
            case 'INVOICE_CREATED':
              return {backgroundColor: '#dfffea', color: '#1fc95f'}
            case 'DISPATCHED':
              return {backgroundColor: '#e9f3ff', color: '#1b84ff'}
            case 'CREATED':
              return {backgroundColor: '#ffeef3', color: '#f8285a'}
            case 'READY_TO_DISPATCH':
            case 'PARTIALLY_FULFILLED':
              return {backgroundColor: '#fff8dd', color: '#f8cb24'}
            case 'VERIFIED':
              return {backgroundColor: '#fff8dd', color: '#f8cb24'}
            case 'COMPLETED':
              return {backgroundColor: '#dfffea', color: '#1fc95f'}
            default:
              return {backgroundColor: '#f5f5f5', color: '#777'} // Default style
          }
        }

        // Get the style for current status
        const statusStyle = getStatusStyle(user.status)

        // Map specific status values to user-friendly labels

        displayStatus =
          user.status === 'PARTIALLY_FULFILLED'
            ? 'In Progress'
            : user.status === 'TRANSPORT_APPROVED'
            ? 'Ready to ship'
            : user.status

        // Return the status with applied styling
        return (
          <span
            style={{
              ...statusStyle,
              padding: '4px 8px',
              borderRadius: '4px',
              fontSize: '12px',
              fontWeight: 'bold',
              display: 'inline-block',
            }}
          >
            {displayStatus}
          </span>
        )
      // case "PDueDate": {
      //   const recyclerPayment = user?.payment?.paymentDetails?.find(
      //     payment => payment.paymentType === "SUPPLIER"
      //   );
      //   const paymentDate = recyclerPayment?.paymentDate;

      //   if (!paymentDate) return "--";

      //   const today = new Date().getTime();
      //   const isOverdue = paymentDate < today;

      //   return (
      //     <div
      //       style={{
      //         backgroundColor: isOverdue ? '#fbbecd' : '#e6ffe6',
      //         color: isOverdue ? '#f1416c' : '#50cd89',
      //         padding: '4px 8px',
      //         borderRadius: '4px',
      //         display: 'inline-block'
      //       }}
      //     >
      //       {formatDateForInput(paymentDate)}
      //     </div>
      //   )
      // }

      case 'PDueDate': {
        const recyclerPayment = user?.payment?.paymentDetails?.find(
          (payment) => payment.paymentType === 'SUPPLIER'
        )
        const paymentDate = recyclerPayment?.paymentDate
        const remainingPayable = recyclerPayment?.remainingPayable

        if (!paymentDate) return '--'

        const today = new Date().getTime()
        const isOverdue = paymentDate < today
        const isPaid = remainingPayable === 0

        return (
          <div
            style={{
              backgroundColor: isPaid ? '#dfffea' : isOverdue ? '#ffeef3' : '#dfffea',
              color: isPaid ? '#17c653' : isOverdue ? '#f8285a' : '#17c653',
              padding: '4px 8px',
              borderRadius: '4px',
              display: 'inline-block',
              fontWeight: 'bold',
            }}
          >
            {isPaid ? 'Paid' : formatDateForInput(paymentDate)}
          </div>
        )
      }

      case 'statusAggregator':
        const baseStyle = {
          fontWeight: 'bold',
          padding: '4px 8px',
          borderRadius: '4px',
          display: 'inline-block',
        }

        return (
          <div
            style={{
              ...baseStyle,
              ...(user.status === 'ACTIVE'
                ? {
                    backgroundColor: '#dfffea',
                    color: '#17c666',
                  }
                : {
                    backgroundColor: '#ffeef3',
                    color: '#f8285a',
                  }),
            }}
          >
            {user.status}
          </div>
        )

      // case "RDueDate": {
      //   const recyclerPayment = user?.payment?.paymentDetails?.find(
      //     payment => payment.paymentType === "RECYCLER"
      //   );
      //   const paymentDate = recyclerPayment?.paymentDate;

      //   if (!paymentDate) return "--";

      //   const today = new Date().getTime();
      //   const isOverdue = paymentDate < today;

      //   return (
      //     <div
      //       style={{
      //         backgroundColor: isOverdue ? '#ffeef3' : '#e6ffe6',
      //         color: isOverdue ? '#f1416c' : '#17c653',
      //         padding: '4px 8px',
      //         borderRadius: '4px',
      //         display: 'inline-block',
      //         fontWeight: "bold"
      //       }}
      //     >
      //       {formatDateForInput(paymentDate)}
      //     </div>
      //   )
      // }

      case 'RDueDate': {
        const recyclerPayment = user?.payment?.paymentDetails?.find(
          (payment) => payment.paymentType === 'RECYCLER'
        )
        const paymentDate = recyclerPayment?.paymentDate
        const remainingPayable = recyclerPayment?.remainingPayable

        if (!paymentDate) return '--'

        const today = new Date().getTime()
        const isOverdue = paymentDate < today
        const isPaid = remainingPayable === 0

        return (
          <div
            style={{
              backgroundColor: isPaid ? '#dfffea' : isOverdue ? '#ffeef3' : '#dfffea',
              color: isPaid ? '#17c653' : isOverdue ? '#f8285a' : '#17c653',
              padding: '4px 8px',
              borderRadius: '4px',
              display: 'inline-block',
              fontWeight: 'bold',
            }}
          >
            {isPaid ? 'Paid' : formatDateForInput(paymentDate)}
          </div>
        )
      }

      case 'createdAtm':
        return user?.createdAt
      case 'logisticContact':
      case 'personalDetailR':
        return (
          <div>
            <p>
              <span>{user?.personalDetails?.mobile}</span>
            </p>
            <p style={{marginTop: '-10px'}}>{user?.personalDetails?.email}</p>
          </div>
        )

      // case 'RAddress': {
      //   return (
      //     <>
      //       <div
      //         className="cursor-pointer text-primary hover:text-primary-dark"
      //         onClick={() => setShowUserTable(true)}
      //       >
      //         Click to view
      //       </div>

      //       <RecyclerAddress
      //         show={showUserTable}
      //         user={user}
      //         onClose={() => setShowUserTable(false)}
      //       />
      //     </>
      //   );
      // }

      case 'RAddress': {
        const isAdmin = (currentUser as any)?.role?.name === 'ADMIN_CXO'
        const isRecyclerPath = location.pathname.includes('/apps/business/recycler')
        const isCollectionPointPath = location.pathname.includes('/apps/business/collection-point')
        const isRecyclerPathFinance = location.pathname.includes('/apps/finance/recycler')
        const isCollectionPointPathFinance = location.pathname.includes(
          '/apps/finance/collection-point'
        )
        const canEdit =
          isAdmin &&
          (isRecyclerPath ||
            isRecyclerPathFinance ||
            isCollectionPointPath ||
            isCollectionPointPathFinance)

        const addressData = user?.address?.[0]
        const hasEmptyFields =
          canEdit &&
          (!addressData?.street ||
            !addressData?.city ||
            !addressData?.state ||
            !addressData?.country ||
            !addressData?.zipCode)

        return (
          <>
            <div
              className='cursor-pointer text-primary hover:text-primary-dark'
              onClick={() => setShowUserTable(true)}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '4px',
                whiteSpace: 'nowrap',
                marginLeft: hasEmptyFields ? '-2px' : '0px',
              }}
            >
              <div style={{width: '13px', height: '13px', flexShrink: 0}}>
                {hasEmptyFields && (
                  <svg
                    width='13'
                    height='13'
                    viewBox='0 0 24 24'
                    fill='none'
                    stroke='red'
                    strokeWidth='2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  >
                    <circle cx='12' cy='12' r='10'></circle>
                    <line x1='12' y1='8' x2='12' y2='12'></line>
                    <line x1='12' y1='16' x2='12.01' y2='16'></line>
                  </svg>
                )}
              </div>
              Click to view
            </div>
            <RecyclerAddress
              show={showUserTable}
              user={user}
              onClose={() => setShowUserTable(false)}
            />
          </>
        )
      }

      case 'PurchseOrderRecyclerAddress': {
        return (
          <>
            <div
              className='cursor-pointer text-primary hover:text-primary-dark'
              onClick={() => setShowUserTable(true)}
            >
              Click to view
            </div>

            <PurchseOrderRecyclerAddress
              show={showUserTable}
              user={user}
              onClose={() => setShowUserTable(false)}
            />
          </>
        )
      }

      case 'tracebilityClick': {
        return (
          <>
            <div
              className='cursor-pointer text-primary hover:text-primary-dark'
              onClick={() => setShowUserTable(true)}
            >
              Click to view
            </div>

            <PurchseOrderRecyclerAddress
              show={showUserTable}
              user={user}
              onClose={() => setShowUserTable(false)}
            />
          </>
        )
      }

      case 'ReconcillationMATERIALPopUp': {
        return (
          <>
            <div
              className='cursor-pointer text-primary hover:text-primary-dark'
              onClick={() => setShowUserTable(true)}
            >
              Click to view
            </div>

            <ReconcillationMATERIALPopUp
              show={showUserTable}
              user={user}
              onClose={() => setShowUserTable(false)}
            />
          </>
        )
      }
      case 'QualityAssessmentMaterialPopUp': {
        return (
          <>
            <div
              className='cursor-pointer text-primary hover:text-primary-dark'
              onClick={() => setShowUserTable(true)}
            >
              Click to view
            </div>

            <QualityAssessmentMaterialPopUp
              show={showUserTable}
              user={user}
              onClose={() => setShowUserTable(false)}
            />
          </>
        )
      }
      case 'QualityASSAddPopUp': {
        return (
          <>
            <div
              className='cursor-pointer text-primary hover:text-primary-dark'
              onClick={() => setShowUserTable(true)}
            >
              Click to view
            </div>

            <QualityASSAddPopUp
              show={showUserTable}
              user={user}
              onClose={() => setShowUserTable(false)}
            />
          </>
        )
      }

      // case 'RBankDetails': {
      //   return (
      //     <>
      //       <div
      //         className="cursor-pointer text-primary hover:text-primary-dark"
      //         onClick={() => setShowUserTable(true)}
      //       >
      //         Click to view
      //       </div>

      //       <RecyclerBankDetails
      //         show={showUserTable}
      //         user={user}
      //         onClose={() => setShowUserTable(false)}
      //       />
      //     </>
      //   );
      // }

      case 'RBankDetails': {
        const isAdmin = (currentUser as any)?.role?.name === 'ADMIN_CXO'
        const isRecyclerPath = location.pathname.includes('/apps/business/recycler')
        const isCollectionPointPath = location.pathname.includes('/apps/business/collection-point')
        const isRecyclerPathFinance = location.pathname.includes('/apps/finance/recycler')
        const isCollectionPointPathFinance = location.pathname.includes(
          '/apps/finance/collection-point'
        )
        const canEdit =
          isAdmin &&
          (isRecyclerPath ||
            isRecyclerPathFinance ||
            isCollectionPointPath ||
            isCollectionPointPathFinance)

        const bankData = user?.bankDetails
        const hasEmptyFields =
          canEdit &&
          (!bankData?.bankName ||
            !bankData?.accountNo ||
            !bankData?.ifscCode ||
            !bankData?.accountName ||
            !bankData?.images?.[0]?.docUrl)

        return (
          <>
            <div
              className='cursor-pointer text-primary hover:text-primary-dark'
              onClick={() => setShowUserTable(true)}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '4px',
                whiteSpace: 'nowrap',
                marginLeft: hasEmptyFields ? '-2px' : '0px',
              }}
            >
              <div style={{width: '13px', height: '13px', flexShrink: 0}}>
                {hasEmptyFields && (
                  <svg
                    width='13'
                    height='13'
                    viewBox='0 0 24 24'
                    fill='none'
                    stroke='red'
                    strokeWidth='2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  >
                    <circle cx='12' cy='12' r='10'></circle>
                    <line x1='12' y1='8' x2='12' y2='12'></line>
                    <line x1='12' y1='16' x2='12.01' y2='16'></line>
                  </svg>
                )}
              </div>
              Click to view
            </div>
            <RecyclerBankDetails
              show={showUserTable}
              user={user}
              onClose={() => setShowUserTable(false)}
            />
          </>
        )
      }

      case 'reconciliationPopUp': {
        return (
          <>
            <div
              className='cursor-pointer text-primary hover:text-primary-dark'
              onClick={() => setShowUserTable(true)}
            >
              Click to view
            </div>

            <ReconiliAddress
              show={showUserTable}
              user={user}
              onClose={() => setShowUserTable(false)}
            />
          </>
        )
      }
      case 'DOpopUp': {
        return (
          <>
            <div
              className='cursor-pointer text-primary hover:text-primary-dark'
              onClick={() => setShowUserTable(true)}
            >
              Click to view
            </div>

            <DOpopUp show={showUserTable} user={user} onClose={() => setShowUserTable(false)} />
          </>
        )
      }
      // case 'kycBankDetails': {
      //   return (
      //     <>
      //       <div
      //         className="cursor-pointer text-primary hover:text-primary-dark"
      //         onClick={() => setShowUserTable(true)}
      //       >
      //         Click to view
      //       </div>

      //       <KycDetails
      //         show={showUserTable}
      //         user={user}
      //         onClose={() => setShowUserTable(false)}
      //       />
      //     </>
      //   );
      // }

      // case 'kycBankDetails': {
      //   const hasDocuments = Boolean(
      //     user?.kycDocument?.some((doc: any) =>
      //       doc?.docType === 'AADHAR' && doc?.docNumber ||
      //       doc?.docType === 'PAN' && doc?.docNumber ||
      //       doc?.docType === 'GST_NUMBER' && doc?.docNumber
      //     )
      //   );

      //   return (
      //     <>
      //       <div
      //         className={hasDocuments
      //           ? "cursor-pointer text-primary hover:text-primary-dark"
      //           : "cursor-not-allowed text-gray-400"}
      //         onClick={() => hasDocuments && setShowUserTable(true)}
      //       >
      //         Click to view
      //       </div>

      //       <KycDetails
      //         show={showUserTable}
      //         user={user}
      //         onClose={() => setShowUserTable(false)}
      //       />
      //     </>
      //   );
      // }
      case 'userManagementAddress': {
        return <div>{generateAddress(user?.address?.[0])}</div>
      }
      case 'userManagementGst': {
        return (
          <div>
            {user?.kycDocument?.filter((item: any) => item.docType === 'GST_CERTIFICATE')[0]
              ?.docNumber || 'N/A'}
          </div>
        )
      }

      case 'transporterName': {
        return (
          <div>{user?.transportType === 'COMPANY' ? 'SELLER' : user?.transportType || 'N/A'}</div>
        )
      }
      case 'registeredAddress': {
        return <div>{user?.address?.[0]?.city + ', ' + user?.address?.[0]?.state}</div>
      }
      case 'bankDetails': {
        return (
          <div>
            <p>
              <span>{user?.bankDetails?.bankName}</span>
            </p>
            <p style={{marginTop: '-10px'}}>{user?.bankDetails?.accountNo}</p>
          </div>
        )
      }

      case 'kycBankDetails': {
        const isAdmin = (currentUser as any)?.role?.name === 'ADMIN_CXO'
        const isRecyclerPath = location.pathname.includes('/apps/business/recycler')
        const isCollectionPointPath = location.pathname.includes('/apps/business/collection-point')
        const isRecyclerPathFinance = location.pathname.includes('/apps/finance/recycler')
        const isCollectionPointPathFinance = location.pathname.includes(
          '/apps/finance/collection-point'
        )
        const canEdit =
          isAdmin &&
          (isRecyclerPath ||
            isRecyclerPathFinance ||
            isCollectionPointPath ||
            isCollectionPointPathFinance)

        const kycData = user?.kycDocument || []
        const hasEmptyFields =
          canEdit &&
          (!kycData.find((doc) => doc.docType === 'AADHAR')?.docNumber ||
            !kycData.find((doc) => doc.docType === 'PAN')?.docNumber ||
            !kycData.find(
              (doc) => doc.docType === 'GST_CERTIFICATE' || doc.docType === 'GST_NUMBER'
            )?.docNumber)

        return (
          <>
            <div
              className='cursor-pointer text-primary hover:text-primary-dark'
              onClick={() => setShowUserTable(true)}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '4px',
                whiteSpace: 'nowrap',
              }}
            >
              <div style={{width: '13px', height: '13px', flexShrink: 0}}>
                {hasEmptyFields && (
                  <svg
                    width='13'
                    height='13'
                    viewBox='0 0 24 24'
                    fill='none'
                    stroke='red'
                    strokeWidth='2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  >
                    <circle cx='12' cy='12' r='10'></circle>
                    <line x1='12' y1='8' x2='12' y2='12'></line>
                    <line x1='12' y1='16' x2='12.01' y2='16'></line>
                  </svg>
                )}
              </div>
              Click to view
            </div>
            <KycDetails show={showUserTable} user={user} onClose={() => setShowUserTable(false)} />
          </>
        )
      }

      // case 'AGGkYC': {
      //   return (
      //     <>
      //       <div
      //         className="cursor-pointer text-primary hover:text-primary-dark"
      //         onClick={() => setShowUserTable(true)}
      //       >
      //         Click to view
      //       </div>

      //       <AggrigatorKyc
      //         show={showUserTable}
      //         user={user}
      //         onClose={() => setShowUserTable(false)}
      //       />
      //     </>
      //   );
      // }

      case 'AGGkYC': {
        const isAdmin = (currentUser as any)?.role?.name === 'ADMIN_CXO'
        const isRecyclerPath = location.pathname.includes('/apps/business/recycler')
        const isCollectionPointPath = location.pathname.includes('/apps/business/collection-point')
        const isRecyclerPathFinance = location.pathname.includes('/apps/finance/recycler')
        const isCollectionPointPathFinance = location.pathname.includes(
          '/apps/finance/collection-point'
        )
        const canEdit =
          isAdmin &&
          (isRecyclerPath ||
            isRecyclerPathFinance ||
            isCollectionPointPath ||
            isCollectionPointPathFinance)

        const kycData = user?.kycDocument || []
        const hasEmptyFields =
          canEdit &&
          (!kycData.find((doc) => doc.docType === 'AADHAR')?.docNumber ||
            !kycData.find((doc) => doc.docType === 'PAN')?.docNumber ||
            !kycData.find(
              (doc) => doc.docType === 'GST_CERTIFICATE' || doc.docType === 'GST_NUMBER'
            )?.docNumber)

        return (
          <>
            <div
              className='cursor-pointer text-primary hover:text-primary-dark'
              onClick={() => setShowUserTable(true)}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '4px',
                whiteSpace: 'nowrap',
                marginLeft: hasEmptyFields ? '-2px' : '0px',
              }}
            >
              <div style={{width: '13px', height: '13px', flexShrink: 0}}>
                {hasEmptyFields && (
                  <svg
                    width='13'
                    height='13'
                    viewBox='0 0 24 24'
                    fill='none'
                    stroke='red'
                    strokeWidth='2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  >
                    <circle cx='12' cy='12' r='10'></circle>
                    <line x1='12' y1='8' x2='12' y2='12'></line>
                    <line x1='12' y1='16' x2='12.01' y2='16'></line>
                  </svg>
                )}
              </div>
              Click to view
            </div>
            <AggrigatorKyc
              show={showUserTable}
              user={user}
              onClose={() => setShowUserTable(false)}
            />
          </>
        )
      }

      case 'PymentInfoPopUp': {
        return (
          <>
            <div
              className='cursor-pointer text-primary hover:text-primary-dark'
              onClick={() => setShowUserTable(true)}
            >
              Click to view
            </div>

            <PaymentInfoPopUp
              show={showUserTable}
              user={user}
              onClose={() => setShowUserTable(false)}
            />
          </>
        )
      }
      case 'DeliveryOrderAddress': {
        return (
          <>
            <div
              className='cursor-pointer text-primary hover:text-primary-dark'
              onClick={() => setShowUserTable(true)}
            >
              Click to view
            </div>

            <DeliveryOrderAddress
              show={showUserTable}
              user={user}
              onClose={() => setShowUserTable(false)}
            />
          </>
        )
      }
      case 'ReconcillationGRNINFOPopUp': {
        return (
          <>
            <div
              className='cursor-pointer text-primary hover:text-primary-dark'
              onClick={() => setShowUserTable(true)}
            >
              Click to view
            </div>

            <ReconcillationGRNINFOPopUp
              show={showUserTable}
              user={user}
              onClose={() => setShowUserTable(false)}
            />
          </>
        )
      }
      case 'AssignVehicleRequirementPopUp': {
        return (
          <>
            <div
              className='cursor-pointer text-primary hover:text-primary-dark'
              onClick={() => setShowUserTable(true)}
            >
              Click to view
            </div>

            <AssignVehicleRequirementPopUp
              show={showUserTable}
              user={user}
              onClose={() => setShowUserTable(false)}
            />
          </>
        )
      }

      // case 'ApprovedListingDetails': {
      //   return (
      //     <>
      //       <div
      //         className="cursor-pointer text-primary hover:text-primary-dark"
      //         onClick={() => setShowUserTable(true)}
      //       >
      //         Click to view
      //       </div>

      //       <ApprovedListingDetails
      //         show={showUserTable}
      //         user={user}
      //         onClose={() => setShowUserTable(false)}
      //       />
      //     </>
      //   );
      // }

      case 'ApprovedListingDetails': {
        // Check if there are valid item details to display
        const hasItemDetails = Boolean(
          user?.orderDetail?.[0]?.items?.[0]?.grade ||
            user?.orderDetail?.[0]?.items?.[0]?.color ||
            user?.packagingType
        )
        return (
          <>
            <div style={{position: 'relative', display: 'inline-block'}}>
              <button
                onClick={() => setDetailsDropdown((prev) => !prev)}
                className='btn btn-sm btn-light-primary'
                style={{minWidth: '100px'}}
              >
                Action
                <KTIcon iconName='down' className='fs-7 ms-2' />
              </button>
              {detailsDropdown && (
                <>
                  <div
                    style={{
                      position: 'fixed',
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      zIndex: 9998,
                    }}
                    onClick={() => setDetailsDropdown(false)}
                  />
                  <div
                    style={{
                      position: 'absolute',
                      top: '100%',
                      right: 0,
                      marginTop: '4px',
                      backgroundColor: 'white',
                      border: '1px solid #e0e0e0',
                      borderRadius: '6px',
                      boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                      minWidth: '120px',
                      zIndex: 9999,
                    }}
                  >
                    <div
                      onClick={() => {
                        hasItemDetails && setShowUserTable(true)
                        setDetailsDropdown(false)
                      }}
                      style={{
                        fontWeight: 'bold',
                        padding: '8px 16px',
                        cursor: 'pointer',
                        color: '#1b84ff',
                      }}
                      onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#f8f9fa')}
                      onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'white')}
                    >
                      Click to view
                    </div>
                    {user?.purchaseOrderDocuments && (
                      <div
                        onClick={() => {
                          try {
                            const url = user?.purchaseOrderDocuments
                            const link = document.createElement('a')
                            link.href = url
                            link.download = 'PurchaseOrder.pdf'
                            link.target = '_blank'
                            link.rel = 'noopener noreferrer'
                            document.body.appendChild(link)
                            link.click()
                            link.remove()
                            window.URL.revokeObjectURL(url)
                            setDetailsDropdown(false)
                          } catch (error) {
                            console.error('Error downloading PO:', error)
                          }
                        }}
                        style={{
                          fontWeight: 'bold',
                          padding: '8px 16px',
                          cursor: 'pointer',
                          color: '#1b84ff',
                        }}
                        onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#f8f9fa')}
                        onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'white')}
                      >
                        Download PO
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>

            {hasItemDetails && (
              <ApprovedListingDetailsMain
                show={showUserTable}
                user={user}
                onClose={() => setShowUserTable(false)}
              />
            )}
          </>
        )
      }
      case 'VerifiedListingDetails': {
        // Check if there are valid item details to display
        const hasItemDetails = Boolean(
          user?.orderDetail?.[0]?.items?.[0]?.grade ||
            user?.orderDetail?.[0]?.items?.[0]?.color ||
            user?.packagingType
        )
        return (
          <>
            <div
              className={
                hasItemDetails
                  ? 'cursor-pointer text-primary hover:text-primary-dark'
                  : 'cursor-not-allowed text-gray-400'
              }
              onClick={() => hasItemDetails && setShowUserTable(true)}
            >
              Click to view
            </div>

            {hasItemDetails && (
              <VerifiedListingDetails
                show={showUserTable}
                user={user}
                onClose={() => setShowUserTable(false)}
              />
            )}
          </>
        )
      }

      case 'statusQUalityAssesment':
        return (
          <span
            style={{
              fontSize: '12px',
              fontWeight: 'bold',
              padding: '5px 10px',
              borderRadius: '6px',
              display: 'inline-block',
              ...(user.status === 'INVOICE_CREATED'
                ? {backgroundColor: '#dfffea', color: '#1fc95f'}
                : user.status === 'READY_TO_DISPATCH'
                ? {backgroundColor: '#fff8dd', color: '#f8cb24'}
                : user.status === 'DISPATCHED'
                ? {backgroundColor: '#e9f3ff', color: '#1b84ff'}
                : user.status === 'CREATED'
                ? {backgroundColor: '#ffeef3', color: '#f8285a'}
                : user.status === 'VERIFIED'
                ? {backgroundColor: '#fff8dd', color: '#f8cb24'}
                : {backgroundColor: '#f5f5f5', color: '#666666'}), // default styling
            }}
          >
            {user.status}
          </span>
        )

      case 'grnRcycler':
        return user?.grnDetails?.recQuantity
      case 'rrCat':
        return user?.dispatchOrderDetail?.[0]?.categoryName
      case 'rrQty':
        return user?.dispatchOrderDetail?.[0]?.items?.[0]?.quantity
      case 'rrItem':
        return user?.dispatchOrderDetail?.[0]?.items?.[0]?.itemName

      case 'cqa':
        return user?.dispatchOrderDetail?.[0]?.categoryName
      case 'iqa':
        return user?.dispatchOrderDetail?.[0]?.items?.[0]?.itemName
      case 'qqa':
        return user?.dispatchOrderDetail?.[0]?.items?.[0]?.quantity

      // case 'PurchaseRequestPopup': {
      //   return (
      //     <>
      //       <div
      //         className="cursor-pointer text-primary hover:text-primary-dark"
      //         onClick={() => setShowUserTable(true)}
      //       >
      //         Click to view
      //       </div>

      //       <ApprovedListingDetails
      //         show={showUserTable}
      //         user={user}
      //         onClose={() => setShowUserTable(false)}
      //       />
      //     </>
      //   );
      // }

      case 'PurchaseRequestPopup': {
        const hasItemDetails = Boolean(
          user?.orderDetail?.[0]?.items?.[0]?.grade ||
            user?.orderDetail?.[0]?.items?.[0]?.color ||
            user?.packagingType
        )

        return (
          <>
            <div
              className={
                hasItemDetails
                  ? 'cursor-pointer text-primary hover:text-primary-dark'
                  : 'cursor-not-allowed text-gray-400'
              }
              onClick={() => hasItemDetails && setShowUserTable(true)}
            >
              Click to view
            </div>

            <PurchaseRequestPopup
              show={showUserTable}
              user={user}
              onClose={() => setShowUserTable(false)}
            />
          </>
        )
      }

      // case 'ListedStockPop': {
      //   return (
      //     <>
      //       <div
      //         className="cursor-pointer text-primary hover:text-primary-dark"
      //         onClick={() => setShowUserTable(true)}
      //       >
      //         Click to view
      //       </div>

      //       <ApprovedListingDetails
      //         show={showUserTable}
      //         user={user}
      //         onClose={() => setShowUserTable(false)}
      //       />
      //     </>
      //   );
      // }
      case 'ListedStockPop': {
        // Check if there are valid item details to display
        const hasItemDetails = Boolean(
          user?.orderDetail?.[0]?.items?.[0]?.grade ||
            user?.orderDetail?.[0]?.items?.[0]?.color ||
            user?.packagingType
        )

        return (
          <>
            {/* <div
              className={hasItemDetails
                ? "cursor-pointer text-primary hover:text-primary-dark"
                : "cursor-not-allowed text-gray-400"}
              onClick={() => hasItemDetails && setShowUserTable(true)}
            >
              Click to view
            </div> */}
            <button
              type='button'
              className={`px-4 py-2 rounded 
    ${
      hasItemDetails
        ? 'cursor-pointer text-white bg-primary hover:bg-primary-dark'
        : 'cursor-not-allowed text-gray-400 bg-gray-200'
    }`}
              onClick={() => hasItemDetails && setShowUserTable(true)}
              disabled={!hasItemDetails}
            >
              Action
            </button>

            {hasItemDetails && (
              <ApprovedListingDetails
                show={showUserTable}
                user={user}
                onClose={() => setShowUserTable(false)}
              />
            )}
          </>
        )
      }

      // case 'OrderMngPop': {
      //   return (
      //     <>
      //       <div
      //         className="cursor-pointer text-primary hover:text-primary-dark"
      //         onClick={() => setShowUserTable(true)}
      //       >
      //         Click to view
      //       </div>

      //       <ApprovedListingDetails
      //         show={showUserTable}
      //         user={user}
      //         onClose={() => setShowUserTable(false)}
      //       />
      //     </>
      //   );
      // }
      case 'OrderMngPop': {
        // Check if there are valid item details to display
        const hasItemDetails = Boolean(
          user?.orderDetail?.[0]?.items?.[0]?.grade ||
            user?.orderDetail?.[0]?.items?.[0]?.color ||
            user?.packagingType
        )

        return (
          <>
            <div
              className={
                hasItemDetails
                  ? 'cursor-pointer text-primary hover:text-primary-dark'
                  : 'cursor-not-allowed text-gray-400'
              }
              onClick={() => hasItemDetails && setShowUserTable(true)}
            >
              Click to view
            </div>

            {hasItemDetails && (
              <OrderMngPopUp
                show={showUserTable}
                user={user}
                onClose={() => setShowUserTable(false)}
              />
            )}
          </>
        )
      }
      case 'AssignedOrderManagementPopUp': {
        return (
          <>
            <div onClick={() => setShowUserTable(true)}>Click to view</div>
            <OrderMngAssigned
              show={showUserTable}
              user={user}
              onClose={() => setShowUserTable(false)}
            />
          </>
        )
      }
      case 'AssignVehicleMaterialPopUp': {
        return (
          <>
            <div onClick={() => setShowUserTable(true)}>Click to view</div>
            <AssignVehicleMaterialPopUp
              show={showUserTable}
              user={user}
              onClose={() => setShowUserTable(false)}
            />
          </>
        )
      }
      // case 'TransportPopUp': {
      //   return (
      //     <>
      //       <div
      //         onClick={() => setShowUserTable(true)}
      //       >
      //         Click to view
      //       </div>
      //       <TransportPopUp
      //         show={showUserTable}
      //         user={user}
      //         onClose={() => setShowUserTable(false)}
      //       />

      //     </>
      //   );
      // }

      // case 'TransportPopUp': {
      //   // Check if basic info exists
      //   const hasBasicInfo = Boolean(
      //     user.assignedSaleOrders?.[0]?.pickupPointId ||
      //     user?.lrNo ||
      //     user?.dcNo ||
      //     user?.invoiceNo
      //   );

      //   // Check if any documents exist
      //   const hasDocuments = user.dispatchImages && user.dispatchImages.some(img =>
      //     ['WEIGHT_SLIP', 'INVOICE', 'LR_RECIEPT'].includes(img.docType)
      //   );

      //   // Combined check
      //   const hasContent = hasBasicInfo || hasDocuments;

      //   return (
      //     <>
      //       <div
      //         onClick={() => hasContent && setShowUserTable(true)}
      //         className={`${hasContent
      //           ? 'cursor-pointer text-primary hover:text-primary-darker'
      //           : 'cursor-not-allowed text-muted opacity-50'
      //           }`}
      //         style={{
      //           userSelect: 'none',
      //           ...(hasContent && {
      //             // textDecoration: 'underline'
      //           })
      //         }}
      //         title={hasContent ? 'Click to view details' : 'No information available'}
      //       >
      //         {hasContent ? 'Click to view' : 'Click to view'}
      //       </div>
      //       {hasContent && (
      //         <TransportPopUp
      //           show={showUserTable}
      //           user={user}
      //           onClose={() => setShowUserTable(false)}
      //         />
      //       )}
      //     </>
      //   );
      // }

      case 'TransportPopUp': {
        return (
          <>
            <div
              // onClick={() => setShowUserTable(true)}
              onClick={() => {
                navigate(`/apps/sales/supply-orders/transport/${user.id}`, {
                  state: {transportInfoData: user},
                })
                setShowUserTable(false)
              }}
              className='cursor-pointer text-primary hover:text-primary-darker'
              style={{
                userSelect: 'none',
              }}
              title='Click to view details'
            >
              Click to view
            </div>
            {/* <TransportPopUp
              show={showUserTable}
              user={user}
              onClose={() => setShowUserTable(false)}
            /> */}
          </>
        )
      }

      case 'TextilePopUp': {
        return (
          <>
            <div
              onClick={() => setShowUserTable(true)}
              className='cursor-pointer text-primary hover:text-primary-darker'
              style={{
                userSelect: 'none',
              }}
              title='Click to view details'
            >
              {location.pathname?.includes('textile/textile-logistics')
                ? 'Logistics Info'
                : 'Click to view'}
            </div>
            {showUserTable && (
              <TextilePopUp
                show={showUserTable}
                user={user}
                onClose={() => setShowUserTable(false)}
              />
            )}
          </>
        )
      }
      case 'TextileSaleOrderPopUp': {
        return (
          <>
            <div
              onClick={() => setShowUserTable(true)}
              className='cursor-pointer text-primary hover:text-primary-darker'
              style={{
                userSelect: 'none',
              }}
              title='Click to view details'
            >
              Click to view
            </div>
            <TextileSaleOrderPopUp
              show={showUserTable}
              user={user}
              onClose={() => setShowUserTable(false)}
            />
          </>
        )
      }

      // case "statusRecycler":
      //   return (
      //     <div
      //       style={{
      //         backgroundColor: "#dfffea",
      //         color: "#5ac853",
      //         borderRadius: "4px",
      //         padding: "4px 8px",
      //         display: "inline-block",
      //         fontWeight: "bold"
      //       }}
      //     >
      //       {user.status}
      //     </div>
      //   )

      // case "paymentAction":
      //   return (
      //     <div style={{ position: 'relative', display: 'inline-block' }}>
      //       <button
      //         onClick={() => setShowPaymentDropdown(!showPaymentDropdown)}
      //         className='btn btn-sm btn-light-primary'
      //         style={{ minWidth: '100px' }}
      //       >
      //         Action
      //         <KTIcon iconName='down' className='fs-7 ms-2' />
      //       </button>
      //       {showPaymentDropdown && (
      //         <>
      //           <div
      //             style={{
      //               position: 'fixed',
      //               top: 0,
      //               left: 0,
      //               right: 0,
      //               bottom: 0,
      //               zIndex: 9998
      //             }}
      //             onClick={() => setShowPaymentDropdown(false)}
      //           />
      //           <div
      //             style={{
      //               position: 'absolute',
      //               top: '100%',
      //               right: 0,
      //               marginTop: '4px',
      //               backgroundColor: 'white',
      //               border: '1px solid #e0e0e0',
      //               borderRadius: '6px',
      //               boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
      //               minWidth: '120px',
      //               zIndex: 9999
      //             }}
      //           >
      //             <div
      //               onClick={() => {
      //                 const authData = localStorage.getItem('kt-auth-react-v')
      //                 const parsedAuth = authData ? JSON.parse(authData) : null
      //                 const token = parsedAuth?.data?.token

      //                 fetch(`${process.env.REACT_APP_BASE_API_URL}dispatchOrders/${user?.orderId}/paymentUpdate/APPROVED`, {
      //                   method: 'PUT',
      //                   headers: {
      //                     'Authorization': `Bearer ${token}`,
      //                     'Content-Type': 'application/json'
      //                   }
      //                 })
      //                 setShowPaymentDropdown(false)
      //               }}
      //               style={{
      //                 fontWeight: 'bold',
      //                 padding: '8px 16px',
      //                 cursor: 'pointer',
      //                 borderBottom: '1px solid #f0f0f0',
      //                 color: '#17c653'
      //               }}
      //               onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
      //               onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
      //             >
      //               Approve
      //             </div>
      //             <div
      //               onClick={() => {
      //                 const authData = localStorage.getItem('kt-auth-react-v')
      //                 const parsedAuth = authData ? JSON.parse(authData) : null
      //                 const token = parsedAuth?.data?.token

      //                 fetch(`${process.env.REACT_APP_BASE_API_URL}dispatchOrders/${user?.orderId}/paymentUpdate/REJECTED`, {
      //                   method: 'PUT',
      //                   headers: {
      //                     'Authorization': `Bearer ${token}`,
      //                     'Content-Type': 'application/json'
      //                   }
      //                 })
      //                 setShowPaymentDropdown(false)
      //               }}
      //               style={{
      //                 fontWeight: 'bold',
      //                 padding: '8px 16px',
      //                 cursor: 'pointer',
      //                 color: '#f8285a'
      //               }}
      //               onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
      //               onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
      //             >
      //               Reject
      //             </div>
      //           </div>
      //         </>
      //       )}
      //     </div>
      //   )

      case 'paymentStatus':
        const statusMap = {
          REQUESTED: 'Initiated',
          APPROVED: 'Approved',
          REJECTED: 'Rejected',
          RECEIVED: 'Verified',
          COMPLETED: 'Paid',
        }

        const paymentStatus = user?.paymentWorkflow?.status
        displayStatus = statusMap[paymentStatus] || paymentStatus

        return displayStatus

      case 'paymentStatusReceived':
        const paymentStatus1 = user?.paymentWorkflow?.status

        if (paymentStatus1 === 'RECEIVED') {
          return (
            <span
              style={{
                backgroundColor: '#e9f3ff',
                color: '#1b84ff',
                padding: '4px 8px',
                borderRadius: '4px',
                fontWeight: 'bold',
                display: 'inline-block',
              }}
            >
              Verified
            </span>
          )
        }
        return paymentStatus1

      case 'totalPricefinance':
        return user?.saleOrderDetail?.totalPrice?.toFixed(2) || '0.00'

      // case "paymentAction":
      //   const authData = localStorage.getItem('kt-auth-react-v')
      //   const parsedAuth = authData ? JSON.parse(authData) : null
      //   const userRole = parsedAuth?.data?.userRole?.name
      //   const token = parsedAuth?.data?.token
      //   const approveEndpoint = userRole === 'PURCHASE_HEAD' ? 'RECEIVED' : 'APPROVED'

      //   return (
      //     <div style={{ position: 'relative', display: 'inline-block' }}>
      //       <button
      //         onClick={() => setShowPaymentDropdown(!showPaymentDropdown)}
      //         className='btn btn-sm btn-light-primary'
      //         style={{ minWidth: '100px' }}
      //       >
      //         Action
      //         <KTIcon iconName='down' className='fs-7 ms-2' />
      //       </button>
      //       {showPaymentDropdown && (
      //         <>
      //           <div
      //             style={{
      //               position: 'fixed',
      //               top: 0,
      //               left: 0,
      //               right: 0,
      //               bottom: 0,
      //               zIndex: 9998
      //             }}
      //             onClick={() => setShowPaymentDropdown(false)}
      //           />
      //           <div
      //             style={{
      //               position: 'absolute',
      //               top: '100%',
      //               right: 0,
      //               marginTop: '4px',
      //               backgroundColor: 'white',
      //               border: '1px solid #e0e0e0',
      //               borderRadius: '6px',
      //               boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
      //               minWidth: '120px',
      //               zIndex: 9999
      //             }}
      //           >
      //             <div
      //               onClick={() => {
      //                 fetch(`${process.env.REACT_APP_BASE_API_URL}dispatch/payment/confirm`, {
      //                   method: 'POST',
      //                   headers: {
      //                     'Authorization': `Bearer ${token}`,
      //                     'Content-Type': 'application/json'
      //                   }
      //                 }).then(() => {
      //                   window.location.reload()
      //                 })
      //                 setShowPaymentDropdown(false)
      //               }}
      //               style={{
      //                 fontWeight: 'bold',
      //                 padding: '8px 16px',
      //                 cursor: 'pointer',
      //                 borderBottom: '1px solid #f0f0f0',
      //                 color: '#17c653'
      //               }}
      //               onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
      //               onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
      //             >
      //               Approve
      //             </div>
      //             <div
      //               onClick={() => {
      //                 fetch(`${process.env.REACT_APP_BASE_API_URL}dispatchOrders/${user?.orderId}/paymentUpdate/REJECTED`, {
      //                   method: 'PUT',
      //                   headers: {
      //                     'Authorization': `Bearer ${token}`,
      //                     'Content-Type': 'application/json'
      //                   }
      //                 }).then(() => {
      //                   window.location.reload()
      //                 })
      //                 setShowPaymentDropdown(false)
      //               }}
      //               style={{
      //                 fontWeight: 'bold',
      //                 padding: '8px 16px',
      //                 cursor: 'pointer',
      //                 color: '#f8285a'
      //               }}
      //               onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
      //               onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
      //             >
      //               Reject
      //             </div>
      //           </div>
      //         </>
      //       )}
      //     </div>
      //   )

      // case "paymentAction":
      //   const authData = localStorage.getItem('kt-auth-react-v')
      //   const parsedAuth = authData ? JSON.parse(authData) : null
      //   const userRole = parsedAuth?.data?.userRole?.name
      //   const token = parsedAuth?.data?.token

      //   const isPurchaseHead = userRole === 'PURCHASE_HEAD'
      //   const endpoint = isPurchaseHead ? 'dispatch/payment/approve' : 'dispatch/payment/confirm'

      //   return (
      //     <div style={{ position: 'relative', display: 'inline-block' }}>
      //       <button
      //         onClick={() => setShowPaymentDropdown(!showPaymentDropdown)}
      //         className='btn btn-sm btn-light-primary'
      //         style={{ minWidth: '100px' }}
      //       >
      //         Action
      //         <KTIcon iconName='down' className='fs-7 ms-2' />
      //       </button>
      //       {showPaymentDropdown && (
      //         <>
      //           <div
      //             style={{
      //               position: 'fixed',
      //               top: 0,
      //               left: 0,
      //               right: 0,
      //               bottom: 0,
      //               zIndex: 9998
      //             }}
      //             onClick={() => setShowPaymentDropdown(false)}
      //           />
      //           <div
      //             style={{
      //               position: 'absolute',
      //               top: '100%',
      //               right: 0,
      //               marginTop: '4px',
      //               backgroundColor: 'white',
      //               border: '1px solid #e0e0e0',
      //               borderRadius: '6px',
      //               boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
      //               minWidth: '120px',
      //               zIndex: 9999
      //             }}
      //           >
      //             <div
      //               onClick={() => {
      //                 const payload = isPurchaseHead
      //                   ? {
      //                     orderId: user?.orderId,
      //                     userId: currentUser?.personalDetails?.name,
      //                     approved: true,
      //                     remark: 'Approved for payment'
      //                   }
      //                   : {
      //                     orderId: user?.orderId,
      //                     userId: currentUser?.personalDetails?.name,
      //                     remark: 'Payment request verified'
      //                   }

      //                 fetch(`${process.env.REACT_APP_BASE_API_URL}${endpoint}`, {
      //                   method: 'POST',
      //                   headers: {
      //                     'Authorization': `Bearer ${token}`,
      //                     'Content-Type': 'application/json'
      //                   },
      //                   body: JSON.stringify(payload)
      //                 })
      //                 setShowPaymentDropdown(false)
      //               }}
      //               style={{
      //                 fontWeight: 'bold',
      //                 padding: '8px 16px',
      //                 cursor: 'pointer',
      //                 borderBottom: '1px solid #f0f0f0',
      //                 color: '#17c653'
      //               }}
      //               onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
      //               onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
      //             >
      //               Approve
      //             </div>
      //             <div
      //               onClick={() => {
      //                 fetch(`${process.env.REACT_APP_BASE_API_URL}dispatchOrders/${user?.orderId}/paymentUpdate/REJECTED`, {
      //                   method: 'PUT',
      //                   headers: {
      //                     'Authorization': `Bearer ${token}`,
      //                     'Content-Type': 'application/json'
      //                   }
      //                 }).then(() => {
      //                   window.location.reload()
      //                 })
      //                 setShowPaymentDropdown(false)
      //               }}
      //               style={{
      //                 fontWeight: 'bold',
      //                 padding: '8px 16px',
      //                 cursor: 'pointer',
      //                 color: '#f8285a'
      //               }}
      //               onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
      //               onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
      //             >
      //               Reject
      //             </div>
      //           </div>
      //         </>
      //       )}
      //     </div>
      //   )

      // case "paymentAction":
      //   const authData = localStorage.getItem('kt-auth-react-v')
      //   const parsedAuth = authData ? JSON.parse(authData) : null
      //   const userRole = parsedAuth?.data?.userRole?.name
      //   const token = parsedAuth?.data?.token

      //   const isPurchaseHead = userRole === 'PURCHASE_HEAD'
      //   const endpoint = isPurchaseHead ? 'dispatch/payment/confirm' : 'dispatch/payment/approve'

      //   return (
      //     <div style={{ position: 'relative', display: 'inline-block' }}>
      //       <button
      //         onClick={() => setShowPaymentDropdown(!showPaymentDropdown)}
      //         className='btn btn-sm btn-light-primary'
      //         style={{ minWidth: '100px' }}
      //       >
      //         Action
      //         <KTIcon iconName='down' className='fs-7 ms-2' />
      //       </button>
      //       {showPaymentDropdown && (
      //         <>
      //           <div
      //             style={{
      //               position: 'fixed',
      //               top: 0,
      //               left: 0,
      //               right: 0,
      //               bottom: 0,
      //               zIndex: 9998
      //             }}
      //             onClick={() => setShowPaymentDropdown(false)}
      //           />
      //           <div
      //             style={{
      //               position: 'absolute',
      //               top: '100%',
      //               right: 0,
      //               marginTop: '4px',
      //               backgroundColor: 'white',
      //               border: '1px solid #e0e0e0',
      //               borderRadius: '6px',
      //               boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
      //               minWidth: '120px',
      //               zIndex: 9999
      //             }}
      //           >
      //             <div
      //               onClick={() => {
      //                 const payload = isPurchaseHead
      //                   ? {
      //                     orderId: user?.orderId,
      //                     userId: currentUser?.id,
      //                     userName: currentUser?.personalDetails?.name,
      //                     remark: 'Payment request verified'
      //                   }
      //                   : {
      //                     orderId: user?.orderId,
      //                     userId: currentUser?.id,
      //                     userName: currentUser?.personalDetails?.name,
      //                     approved: true,
      //                     remark: 'Approved for payment'
      //                   }

      //                 fetch(`${process.env.REACT_APP_BASE_API_URL}${endpoint}`, {
      //                   method: 'POST',
      //                   headers: {
      //                     'Authorization': `Bearer ${token}`,
      //                     'Content-Type': 'application/json'
      //                   },
      //                   body: JSON.stringify(payload)
      //                 }).then(() => {
      //                   window.location.reload()
      //                 })
      //                 setShowPaymentDropdown(false)
      //               }}
      //               style={{
      //                 fontWeight: 'bold',
      //                 padding: '8px 16px',
      //                 cursor: 'pointer',
      //                 borderBottom: '1px solid #f0f0f0',
      //                 color: '#17c653'
      //               }}
      //               onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
      //               onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
      //             >
      //               Approve
      //             </div>
      //             <div
      //               onClick={() => {
      //                 fetch(`${process.env.REACT_APP_BASE_API_URL}dispatchOrders/${user?.orderId}/paymentUpdate/REJECTED`, {
      //                   method: 'PUT',
      //                   headers: {
      //                     'Authorization': `Bearer ${token}`,
      //                     'Content-Type': 'application/json'
      //                   }
      //                 }).then(() => {
      //                   window.location.reload()
      //                 })
      //                 setShowPaymentDropdown(false)
      //               }}
      //               style={{
      //                 fontWeight: 'bold',
      //                 padding: '8px 16px',
      //                 cursor: 'pointer',
      //                 color: '#f8285a'
      //               }}
      //               onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
      //               onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
      //             >
      //               Reject
      //             </div>
      //           </div>
      //         </>
      //       )}
      //     </div>
      //   )

      // case "paymentAction":
      //   const authData = localStorage.getItem('kt-auth-react-v')
      //   const parsedAuth = authData ? JSON.parse(authData) : null
      //   const userRole = parsedAuth?.data?.userRole?.name
      //   const token = parsedAuth?.data?.token

      //   const isPurchaseHead = userRole === 'PURCHASE_HEAD'
      //   const endpoint = isPurchaseHead ? 'dispatch/payment/confirm' : 'dispatch/payment/approve'

      //   return (
      //     <div style={{ position: 'relative', display: 'inline-block' }}>
      //       <button
      //         onClick={() => setShowPaymentDropdown(!showPaymentDropdown)}
      //         className='btn btn-sm btn-light-primary'
      //         style={{ minWidth: '100px' }}
      //       >
      //         Action
      //         <KTIcon iconName='down' className='fs-7 ms-2' />
      //       </button>
      //       {showPaymentDropdown && (
      //         <>
      //           <div
      //             style={{
      //               position: 'fixed',
      //               top: 0,
      //               left: 0,
      //               right: 0,
      //               bottom: 0,
      //               zIndex: 9998
      //             }}
      //             onClick={() => setShowPaymentDropdown(false)}
      //           />
      //           <div
      //             style={{
      //               position: 'absolute',
      //               top: '100%',
      //               right: 0,
      //               marginTop: '4px',
      //               backgroundColor: 'white',
      //               border: '1px solid #e0e0e0',
      //               borderRadius: '6px',
      //               boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
      //               minWidth: '120px',
      //               zIndex: 9999
      //             }}
      //           >
      //             <div
      //               onClick={() => {
      //                 const payload = isPurchaseHead
      //                   ? {
      //                     orderId: user?.orderId,
      //                     userId: currentUser?.id,
      //                     userName: currentUser?.personalDetails?.name,
      //                     remark: 'Payment request verified'
      //                   }
      //                   : {
      //                     orderId: user?.orderId,
      //                     userId: currentUser?.id,
      //                     userName: currentUser?.personalDetails?.name,
      //                     approved: true,
      //                     remark: 'Approved for payment'
      //                   }

      //                 fetch(`${process.env.REACT_APP_BASE_API_URL}${endpoint}`, {
      //                   method: 'POST',
      //                   headers: {
      //                     'Authorization': `Bearer ${token}`,
      //                     'Content-Type': 'application/json'
      //                   },
      //                   body: JSON.stringify(payload)
      //                 })
      //                 setShowPaymentDropdown(false)
      //               }}
      //               style={{
      //                 fontWeight: 'bold',
      //                 padding: '8px 16px',
      //                 cursor: 'pointer',
      //                 borderBottom: '1px solid #f0f0f0',
      //                 color: '#17c653'
      //               }}
      //               onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
      //               onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
      //             >
      //               Approve
      //             </div>
      //             <div
      //               onClick={() => {
      //                 const payload = {
      //                   orderId: user?.orderId,
      //                   userId: currentUser?.id,
      //                   userName: currentUser?.personalDetails?.name,
      //                   approved: false,
      //                   remark: 'Rejected for payment'
      //                 }

      //                 fetch(`${process.env.REACT_APP_BASE_API_URL}dispatch/payment/approve`, {
      //                   method: 'POST',
      //                   headers: {
      //                     'Authorization': `Bearer ${token}`,
      //                     'Content-Type': 'application/json'
      //                   },
      //                   body: JSON.stringify(payload)
      //                 })
      //                 setShowPaymentDropdown(false)
      //               }}
      //               style={{
      //                 fontWeight: 'bold',
      //                 padding: '8px 16px',
      //                 cursor: 'pointer',
      //                 color: '#f8285a'
      //               }}
      //               onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
      //               onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
      //             >
      //               Reject
      //             </div>
      //           </div>
      //         </>
      //       )}
      //     </div>
      //   )

      case 'textileDate':
        const dateStr = user?.audit?.createdAt
        if (dateStr) {
          return dateStr.split('T')[0]
        }
        return ''

      case 'paymentAction':
        const authData = localStorage.getItem('kt-auth-react-v')
        const parsedAuth = authData ? JSON.parse(authData) : null
        const userRole = parsedAuth?.data?.userRole?.name
        const token = parsedAuth?.data?.token

        const isPurchaseHead = userRole === 'PURCHASE_HEAD'
        const endpoint = isPurchaseHead ? 'dispatch/payment/confirm' : 'dispatch/payment/approve'

        return (
          <div style={{position: 'relative', display: 'inline-block'}}>
            <button
              onClick={() => setShowPaymentDropdown(!showPaymentDropdown)}
              className='btn btn-sm btn-light-primary'
              style={{minWidth: '100px'}}
            >
              Action
              <KTIcon iconName='down' className='fs-7 ms-2' />
            </button>
            {showPaymentDropdown && (
              <>
                <div
                  style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 9998,
                  }}
                  onClick={() => setShowPaymentDropdown(false)}
                />
                <div
                  style={{
                    position: 'absolute',
                    top: '100%',
                    right: 0,
                    marginTop: '4px',
                    backgroundColor: 'white',
                    border: '1px solid #e0e0e0',
                    borderRadius: '6px',
                    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                    minWidth: '120px',
                    zIndex: 9999,
                  }}
                >
                  <div
                    onClick={() => {
                      const payload = isPurchaseHead
                        ? {
                            orderId: user?.orderId,
                            userId: currentUser?.id,
                            userName: currentUser?.personalDetails?.name,
                            remark: 'Payment request verified',
                          }
                        : {
                            orderId: user?.orderId,
                            userId: currentUser?.id,
                            userName: currentUser?.personalDetails?.name,
                            approved: true,
                            remark: 'Approved for payment',
                          }

                      fetch(`${process.env.REACT_APP_BASE_API_URL}${endpoint}`, {
                        method: 'POST',
                        headers: {
                          Authorization: `Bearer ${token}`,
                          'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(payload),
                      }).then(() => {
                        window.location.reload()
                      })
                      setShowPaymentDropdown(false)
                    }}
                    style={{
                      fontWeight: 'bold',
                      padding: '8px 16px',
                      cursor: 'pointer',
                      borderBottom: '1px solid #f0f0f0',
                      color: '#17c653',
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#f8f9fa')}
                    onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'white')}
                  >
                    Approve
                  </div>
                  <div
                    onClick={() => {
                      const payload = {
                        orderId: user?.orderId,
                        userId: currentUser?.id,
                        userName: currentUser?.personalDetails?.name,
                        approved: false,
                        remark: 'Rejected for payment',
                      }

                      fetch(`${process.env.REACT_APP_BASE_API_URL}dispatch/payment/approve`, {
                        method: 'POST',
                        headers: {
                          Authorization: `Bearer ${token}`,
                          'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(payload),
                      }).then(() => {
                        window.location.reload()
                      })
                      setShowPaymentDropdown(false)
                    }}
                    style={{
                      fontWeight: 'bold',
                      padding: '8px 16px',
                      cursor: 'pointer',
                      color: '#f8285a',
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#f8f9fa')}
                    onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'white')}
                  >
                    Reject
                  </div>
                </div>
              </>
            )}
          </div>
        )

      case 'statusRecycler':
        return (
          <div
            style={{
              backgroundColor: user.status === 'INACTIVE' ? '#ffeef3' : '#dfffea',
              color: user.status === 'INACTIVE' ? '#f8285a' : '#5ac853',
              borderRadius: '4px',
              padding: '4px 8px',
              display: 'inline-block',
              fontWeight: 'bold',
            }}
          >
            {user.status}
          </div>
        )

      case 'catRE':
        return user.dispatchOrderDetail?.[0]?.categoryName
      case 'catIt':
        return user.dispatchOrderDetail?.[0]?.items?.[0]?.itemName
      case 'catQty':
        return user.dispatchOrderDetail?.[0]?.items?.[0]?.quantity

      // user info
      case 'supdate':
        return formatDateForInput(user?.deliveryDate)
      case 'userName':
        return user?.personalDetails?.name
      case 'userRole':
        return user?.role?.name
      case 'userContact':
        return user?.personalDetails?.mobile
      case 'userEmail':
        return user?.personalDetails?.email
      case 'userjoiningDate':
        if (user?.createdAt) {
          const date = new Date(user.createdAt)
          const day = date.getDate().toString().padStart(2, '0')
          const month = (date.getMonth() + 1).toString().padStart(2, '0')
          const year = date.getFullYear().toString().slice(-2)
          return `${day}/${month}/${year}`
        }
        return ''

      // roleBusiness

      // roles mapping
      case 'roleBusiness':
        // Find the business role object in the user.role array
        const businessRole = user?.role?.find((role) => role.type === 'BUSINESS')

        // If business role exists, get the permissions
        if (businessRole) {
          const permissions = businessRole.permissions

          // Return 4 smaller boxes with appropriate colors based on permission values
          return (
            <div style={{display: 'flex', gap: '4px'}}>
              <div
                style={{
                  width: '18px',
                  height: '18px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: '1px solid #ddd',
                  borderRadius: '3px',
                  // color: permissions.create ? '#28a745' : '#aaa',
                  backgroundColor: permissions.create ? '#17c666' : 'transparent',
                  color: permissions.create ? 'white' : '#aaa',
                  fontWeight: 'bold',
                  fontSize: '10px',
                }}
              >
                C
              </div>

              <div
                style={{
                  width: '18px',
                  height: '18px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: '1px solid #ddd',
                  borderRadius: '3px',
                  // color: permissions.view ? '#28a745' : '#aaa',
                  backgroundColor: permissions.view ? '#17c666' : 'transparent',
                  color: permissions.view ? 'white' : '#aaa',
                  fontWeight: 'bold',
                  fontSize: '10px',
                }}
              >
                V
              </div>

              <div
                style={{
                  width: '18px',
                  height: '18px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: '1px solid #ddd',
                  borderRadius: '3px',
                  // color: permissions.update ? '#28a745' : '#aaa',
                  backgroundColor: permissions.update ? '#17c666' : 'transparent',
                  color: permissions.update ? 'white' : '#aaa',
                  fontWeight: 'bold',
                  fontSize: '10px',
                }}
              >
                U
              </div>

              <div
                style={{
                  width: '18px',
                  height: '18px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: '1px solid #ddd',
                  borderRadius: '3px',
                  // color: permissions.delete ? '#28a745' : '#aaa',
                  backgroundColor: permissions.delete ? '#17c666' : 'transparent',
                  color: permissions.delete ? 'white' : '#aaa',
                  fontWeight: 'bold',
                  fontSize: '10px',
                }}
              >
                D
              </div>
            </div>
          )
        }

        // If no business role found, return empty boxes
        return (
          <div style={{display: 'flex', gap: '4px'}}>
            <div
              style={{
                width: '18px',
                height: '18px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '1px solid #ddd',
                borderRadius: '3px',
                color: '#aaa',
                fontWeight: 'bold',
                fontSize: '10px',
              }}
            >
              C
            </div>
            <div
              style={{
                width: '18px',
                height: '18px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '1px solid #ddd',
                borderRadius: '3px',
                color: '#aaa',
                fontWeight: 'bold',
                fontSize: '10px',
              }}
            >
              V
            </div>
            <div
              style={{
                width: '18px',
                height: '18px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '1px solid #ddd',
                borderRadius: '3px',
                color: '#aaa',
                fontWeight: 'bold',
                fontSize: '10px',
              }}
            >
              U
            </div>
            <div
              style={{
                width: '18px',
                height: '18px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '1px solid #ddd',
                borderRadius: '3px',
                color: '#aaa',
                fontWeight: 'bold',
                fontSize: '10px',
              }}
            >
              D
            </div>
          </div>
        )

      case 'roleFinance':
        // Find the business role object in the user.role array
        const financeRole = user?.role?.find((role) => role.type === 'FINANCE')

        // If business role exists, get the permissions
        if (financeRole) {
          const permissions = financeRole.permissions

          // Return 4 smaller boxes with appropriate colors based on permission values
          return (
            <div style={{display: 'flex', gap: '4px'}}>
              <div
                style={{
                  width: '18px',
                  height: '18px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: '1px solid #ddd',
                  borderRadius: '3px',
                  // color: permissions.create ? '#28a745' : '#aaa',
                  backgroundColor: permissions.create ? '#17c666' : 'transparent',
                  color: permissions.create ? 'white' : '#aaa',
                  fontWeight: 'bold',
                  fontSize: '10px',
                }}
              >
                C
              </div>

              <div
                style={{
                  width: '18px',
                  height: '18px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: '1px solid #ddd',
                  borderRadius: '3px',
                  // color: permissions.view ? '#28a745' : '#aaa',
                  backgroundColor: permissions.view ? '#17c666' : 'transparent',
                  color: permissions.view ? 'white' : '#aaa',
                  fontWeight: 'bold',
                  fontSize: '10px',
                }}
              >
                V
              </div>

              <div
                style={{
                  width: '18px',
                  height: '18px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: '1px solid #ddd',
                  borderRadius: '3px',
                  // color: permissions.update ? '#28a745' : '#aaa',
                  backgroundColor: permissions.update ? '#17c666' : 'transparent',
                  color: permissions.update ? 'white' : '#aaa',
                  fontWeight: 'bold',
                  fontSize: '10px',
                }}
              >
                U
              </div>

              <div
                style={{
                  width: '18px',
                  height: '18px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: '1px solid #ddd',
                  borderRadius: '3px',
                  // color: permissions.delete ? '#28a745' : '#aaa',
                  backgroundColor: permissions.delete ? '#17c666' : 'transparent',
                  color: permissions.delete ? 'white' : '#aaa',
                  fontWeight: 'bold',
                  fontSize: '10px',
                }}
              >
                D
              </div>
            </div>
          )
        }

        // If no business role found, return empty boxes
        return (
          <div style={{display: 'flex', gap: '4px'}}>
            <div
              style={{
                width: '18px',
                height: '18px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '1px solid #ddd',
                borderRadius: '3px',
                color: '#aaa',
                fontWeight: 'bold',
                fontSize: '10px',
              }}
            >
              C
            </div>
            <div
              style={{
                width: '18px',
                height: '18px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '1px solid #ddd',
                borderRadius: '3px',
                color: '#aaa',
                fontWeight: 'bold',
                fontSize: '10px',
              }}
            >
              V
            </div>
            <div
              style={{
                width: '18px',
                height: '18px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '1px solid #ddd',
                borderRadius: '3px',
                color: '#aaa',
                fontWeight: 'bold',
                fontSize: '10px',
              }}
            >
              U
            </div>
            <div
              style={{
                width: '18px',
                height: '18px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '1px solid #ddd',
                borderRadius: '3px',
                color: '#aaa',
                fontWeight: 'bold',
                fontSize: '10px',
              }}
            >
              D
            </div>
          </div>
        )

      case 'rolePurchase':
        // Find the business role object in the user.role array
        const purchaseRole = user?.role?.find((role) => role.type === 'PURCHASE')

        // If business role exists, get the permissions
        if (purchaseRole) {
          const permissions = purchaseRole.permissions

          // Return 4 smaller boxes with appropriate colors based on permission values
          return (
            <div style={{display: 'flex', gap: '4px'}}>
              <div
                style={{
                  width: '18px',
                  height: '18px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: '1px solid #ddd',
                  borderRadius: '3px',
                  // color: permissions.create ? '#28a745' : '#aaa',
                  backgroundColor: permissions.create ? '#17c666' : 'transparent',
                  color: permissions.create ? 'white' : '#aaa',
                  fontWeight: 'bold',
                  fontSize: '10px',
                }}
              >
                C
              </div>

              <div
                style={{
                  width: '18px',
                  height: '18px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: '1px solid #ddd',
                  borderRadius: '3px',
                  // color: permissions.view ? '#28a745' : '#aaa',
                  backgroundColor: permissions.view ? '#17c666' : 'transparent',
                  color: permissions.view ? 'white' : '#aaa',
                  fontWeight: 'bold',
                  fontSize: '10px',
                }}
              >
                V
              </div>

              <div
                style={{
                  width: '18px',
                  height: '18px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: '1px solid #ddd',
                  borderRadius: '3px',
                  // color: permissions.update ? '#28a745' : '#aaa',
                  backgroundColor: permissions.update ? '#17c666' : 'transparent',
                  color: permissions.update ? 'white' : '#aaa',
                  fontWeight: 'bold',
                  fontSize: '10px',
                }}
              >
                U
              </div>

              <div
                style={{
                  width: '18px',
                  height: '18px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: '1px solid #ddd',
                  borderRadius: '3px',
                  // color: permissions.delete ? '#28a745' : '#aaa',
                  backgroundColor: permissions.delete ? '#17c666' : 'transparent',
                  color: permissions.delete ? 'white' : '#aaa',
                  fontWeight: 'bold',
                  fontSize: '10px',
                }}
              >
                D
              </div>
            </div>
          )
        }

        // If no business role found, return empty boxes
        return (
          <div style={{display: 'flex', gap: '4px'}}>
            <div
              style={{
                width: '18px',
                height: '18px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '1px solid #ddd',
                borderRadius: '3px',
                color: '#aaa',
                fontWeight: 'bold',
                fontSize: '10px',
              }}
            >
              C
            </div>
            <div
              style={{
                width: '18px',
                height: '18px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '1px solid #ddd',
                borderRadius: '3px',
                color: '#aaa',
                fontWeight: 'bold',
                fontSize: '10px',
              }}
            >
              V
            </div>
            <div
              style={{
                width: '18px',
                height: '18px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '1px solid #ddd',
                borderRadius: '3px',
                color: '#aaa',
                fontWeight: 'bold',
                fontSize: '10px',
              }}
            >
              U
            </div>
            <div
              style={{
                width: '18px',
                height: '18px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '1px solid #ddd',
                borderRadius: '3px',
                color: '#aaa',
                fontWeight: 'bold',
                fontSize: '10px',
              }}
            >
              D
            </div>
          </div>
        )

      case 'roleSale':
        // Find the business role object in the user.role array
        const saleRole = user?.role?.find((role) => role.type === 'SALE')

        // If business role exists, get the permissions
        if (saleRole) {
          const permissions = saleRole.permissions

          // Return 4 smaller boxes with appropriate colors based on permission values
          return (
            <div style={{display: 'flex', gap: '4px'}}>
              <div
                style={{
                  width: '18px',
                  height: '18px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: '1px solid #ddd',
                  borderRadius: '3px',
                  // color: permissions.create ? '#28a745' : '#aaa',
                  backgroundColor: permissions.create ? '#17c666' : 'transparent',
                  color: permissions.create ? 'white' : '#aaa',
                  fontWeight: 'bold',
                  fontSize: '10px',
                }}
              >
                C
              </div>

              <div
                style={{
                  width: '18px',
                  height: '18px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: '1px solid #ddd',
                  borderRadius: '3px',
                  // color: permissions.view ? '#28a745' : '#aaa',
                  backgroundColor: permissions.view ? '#17c666' : 'transparent',
                  color: permissions.view ? 'white' : '#aaa',
                  fontWeight: 'bold',
                  fontSize: '10px',
                }}
              >
                V
              </div>

              <div
                style={{
                  width: '18px',
                  height: '18px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: '1px solid #ddd',
                  borderRadius: '3px',
                  // color: permissions.update ? '#28a745' : '#aaa',
                  backgroundColor: permissions.update ? '#17c666' : 'transparent',
                  color: permissions.update ? 'white' : '#aaa',
                  fontWeight: 'bold',
                  fontSize: '10px',
                }}
              >
                U
              </div>

              <div
                style={{
                  width: '18px',
                  height: '18px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: '1px solid #ddd',
                  borderRadius: '3px',
                  // color: permissions.delete ? '#28a745' : '#aaa',
                  backgroundColor: permissions.delete ? '#17c666' : 'transparent',
                  color: permissions.delete ? 'white' : '#aaa',
                  fontWeight: 'bold',
                  fontSize: '10px',
                }}
              >
                D
              </div>
            </div>
          )
        }

        // If no business role found, return empty boxes
        return (
          <div style={{display: 'flex', gap: '4px'}}>
            <div
              style={{
                width: '18px',
                height: '18px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '1px solid #ddd',
                borderRadius: '3px',
                color: '#aaa',
                fontWeight: 'bold',
                fontSize: '10px',
              }}
            >
              C
            </div>
            <div
              style={{
                width: '18px',
                height: '18px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '1px solid #ddd',
                borderRadius: '3px',
                color: '#aaa',
                fontWeight: 'bold',
                fontSize: '10px',
              }}
            >
              V
            </div>
            <div
              style={{
                width: '18px',
                height: '18px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '1px solid #ddd',
                borderRadius: '3px',
                color: '#aaa',
                fontWeight: 'bold',
                fontSize: '10px',
              }}
            >
              U
            </div>
            <div
              style={{
                width: '18px',
                height: '18px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '1px solid #ddd',
                borderRadius: '3px',
                color: '#aaa',
                fontWeight: 'bold',
                fontSize: '10px',
              }}
            >
              D
            </div>
          </div>
        )

      case 'roleLogistics':
        // Find the business role object in the user.role array
        const logisticsRole = user?.role?.find((role) => role.type === 'LOGISTIC')

        // If business role exists, get the permissions
        if (logisticsRole) {
          const permissions = logisticsRole.permissions

          // Return 4 smaller boxes with appropriate colors based on permission values
          return (
            <div style={{display: 'flex', gap: '4px'}}>
              <div
                style={{
                  width: '18px',
                  height: '18px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: '1px solid #ddd',
                  borderRadius: '3px',
                  // color: permissions.create ? '#28a745' : '#aaa',
                  backgroundColor: permissions.create ? '#17c666' : 'transparent',
                  color: permissions.create ? 'white' : '#aaa',
                  fontWeight: 'bold',
                  fontSize: '10px',
                }}
              >
                C
              </div>

              <div
                style={{
                  width: '18px',
                  height: '18px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: '1px solid #ddd',
                  borderRadius: '3px',
                  // color: permissions.view ? '#28a745' : '#aaa',
                  backgroundColor: permissions.view ? '#17c666' : 'transparent',
                  color: permissions.view ? 'white' : '#aaa',
                  fontWeight: 'bold',
                  fontSize: '10px',
                }}
              >
                V
              </div>

              <div
                style={{
                  width: '18px',
                  height: '18px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: '1px solid #ddd',
                  borderRadius: '3px',
                  // color: permissions.update ? '#28a745' : '#aaa',
                  backgroundColor: permissions.update ? '#17c666' : 'transparent',
                  color: permissions.update ? 'white' : '#aaa',
                  fontWeight: 'bold',
                  fontSize: '10px',
                }}
              >
                U
              </div>

              <div
                style={{
                  width: '18px',
                  height: '18px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: '1px solid #ddd',
                  borderRadius: '3px',
                  // color: permissions.delete ? '#28a745' : '#aaa',
                  backgroundColor: permissions.delete ? '#17c666' : 'transparent',
                  color: permissions.delete ? 'white' : '#aaa',
                  fontWeight: 'bold',
                  fontSize: '10px',
                }}
              >
                D
              </div>
            </div>
          )
        }

        // If no business role found, return empty boxes
        return (
          <div style={{display: 'flex', gap: '4px'}}>
            <div
              style={{
                width: '18px',
                height: '18px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '1px solid #ddd',
                borderRadius: '3px',
                color: '#aaa',
                fontWeight: 'bold',
                fontSize: '10px',
              }}
            >
              C
            </div>
            <div
              style={{
                width: '18px',
                height: '18px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '1px solid #ddd',
                borderRadius: '3px',
                color: '#aaa',
                fontWeight: 'bold',
                fontSize: '10px',
              }}
            >
              V
            </div>
            <div
              style={{
                width: '18px',
                height: '18px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '1px solid #ddd',
                borderRadius: '3px',
                color: '#aaa',
                fontWeight: 'bold',
                fontSize: '10px',
              }}
            >
              U
            </div>
            <div
              style={{
                width: '18px',
                height: '18px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '1px solid #ddd',
                borderRadius: '3px',
                color: '#aaa',
                fontWeight: 'bold',
                fontSize: '10px',
              }}
            >
              D
            </div>
          </div>
        )

      case 'pickup_address':
        return clipText(generateAddress(user.pickupInfo?.address))
      case 'address':
        // return generateAddress(user.address || user.pickupInfo?.address)

        const addressConcat = generateAddress(
          user.address || user.pickupInfo?.address || user.dropOffPointInfo?.address
        )
        return (
          <div data-bs-toggle='tooltip' title={addressConcat}>
            {clipText(addressConcat, 30)}
          </div>
        )
      case 'manager':
        return user.companyDetails.name
      case 'geoLocation':
        // return user.address.latitute + ' , ' + user.address.longitute
        return (
          <>
            <div>{user.address.latitute}</div>
            <div>{user.address.longitute}</div>
          </>
        )
      case 'pickupCompletedAt':
        return (
          (user?.pickupInfo?.pickupCompletedAt &&
            new Date(+user?.pickupInfo?.pickupCompletedAt || new Date()).toLocaleDateString(
              'en-GB'
            )) ||
          ''
        )

      case 'pickupDate':
        return new Date(+user?.pickupInfo?.pickupDate || new Date()).toLocaleDateString('en-GB')

      // case 'pickupDateN':
      //   return user?.completedAt
      case 'pickupDateN':
        const timestamp = user?.completedAt
        if (timestamp) {
          const date = new Date(timestamp)

          // Extract day, month, and year
          const day = String(date.getDate()).padStart(2, '0') // Ensure 2-digit format
          const month = String(date.getMonth() + 1).padStart(2, '0') // Month is 0-indexed, add 1
          const year = String(date.getFullYear()).slice(-2) // Get last two digits of the year

          // Format the date as dd/mm/yy
          return `${day}/${month}/${year}`
        }
        return null // Return null or fallback value if `completedAt` is undefined or null

      case 'pickupInfoName':
        return clipText(user?.pickupInfo?.name, 15, '...')
      case 'centreNameY':
        return clipText(user?.pickupInfo?.centreName, 15, '...')
      case 'aa':
        return <>+28%</>

      case 'paymentMode':
        return (
          <span
            className={`badge badge-light-${
              user?.[mapData] === 'CASH'
                ? 'info'
                : user?.[mapData] === 'WALLET'
                ? 'primary'
                : 'success'
            } fs-7 fw-bold`}
          >
            {user?.[mapData] || user?.personalDetails?.[mapData]}
          </span>
        )
      case 'pickupointId':
        return (
          user?.pickupointId?.map((eachData, len) => (
            <div>
              {eachData?.pickupPointName || '-'}
              {len === user.pickupointId.length - 1 ? (
                ''
              ) : (
                <>
                  {' '}
                  , <br />
                </>
              )}
            </div>
          )) || ''
        )
      case 'street':
        return clipText(user.address.street)
      case 'createdAt':
      case 'start':
      case 'end':
        return (
          <div style={{display: 'flex', alignItems: 'flex-start', gap: '10px'}}>
            <div
              style={{
                width: '14px',
                height: '14px',
                borderRadius: '50%',
                backgroundColor: '#e8f5e9',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
              }}
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='12'
                height='12'
                viewBox='0 0 24 24'
                fill='none'
                stroke='#003B73'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
              >
                <rect x='3' y='4' width='18' height='18' rx='2' ry='2' />
                <line x1='16' y1='2' x2='16' y2='6' />
                <line x1='8' y1='2' x2='8' y2='6' />
                <line x1='3' y1='10' x2='21' y2='10' />
              </svg>
            </div>

            <span>{new Date(+user[mapData] || new Date()).toLocaleDateString('en-GB')}</span>
          </div>
        )

      case 'RecyclerName':
        return (
          <div style={{display: 'flex', alignItems: 'flex-start', gap: '10px'}}>
            <div
              style={{
                width: '14px',
                height: '14px',
                borderRadius: '50%',
                backgroundColor: '#e8f5e9',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
              }}
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='12'
                height='12'
                viewBox='0 0 24 24'
                fill='none'
                stroke='#34A853'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
              >
                <path d='M7.86 2.34 6.05 5.5a1 1 0 0 0 .87 1.5h3.17' />
                <path d='m7.86 2.34 3.46 2' />

                <path d='m21.95 10.5-1.82-3.16a1 1 0 0 0-1.73 0l-1.59 2.74' />
                <path d='m21.95 10.5-3.46 2' />

                <path d='m16.14 21.66 1.82-3.16a1 1 0 0 0-.87-1.5h-3.17' />
                <path d='m16.14 21.66-3.46-2' />

                <path d='M4.5 13H2' />
                <path d='M22 13h-2.5' />
                <path d='M12 22v-2.5' />
              </svg>
            </div>

            <span>{user?.companyName}</span>
          </div>
        )

      case 'productionItemDetailsQuantity':
        return user['productionItemDetails']?.map((x: any, ind: number) => (
          <div key={ind + 1 + ''}>{x.quantity}</div>
        ))
      case 'totalAmount':
        return 'RM  ' + user.totalAmount
      case 'cityProvince':
        return user.address.city + ' , ' + user.address.state
      case 'inMaterials':
      case 'outMaterials':
      case 'productionItemDetails':
        return user[mapData]?.map((x: any, ind: number) => (
          <div key={ind + 1 + ''}>{x.name || x.itemName}</div>
        ))
      case 'status':
        const statusData = user?.[mapData] || user?.personalDetails?.[mapData]
        switch (statusData?.toLowerCase()) {
          case 'quantitydeposit':
            return <span className='text-primary fs-7 fw-bold'>+28%</span>
          case 'pickup completed':
          case 'completed':
          case 'accepted':
            return <span className='badge badge-light-success fs-7 fw-bold'>{statusData}</span>
          // return <span className='badge badge-light-danger fs-7 fw-bold'>{statusData}</span>
          case 'created':
            return <span className='badge badge-light-warning fs-7 fw-bold'>{statusData}</span>
          case 'rejected':
            return <span className='badge badge-light-danger fs-7 fw-bold'>{statusData}</span>
          case 'pickup assigned':
            return <span className='badge badge-light-primary fs-7 fw-bold'>{statusData}</span>

          default:
            return user?.[mapData] || user?.personalDetails?.[mapData]
        }
      default:
        return typeof user[mapData] === 'boolean' ? (
          user[mapData] ? (
            'Yes'
          ) : (
            'No'
          )
        ) : typeof user[mapData] === 'number' ? (
          user?.[mapData] === 0 ? (
            <span className='badge badge-light-danger fs-7 fw-bold'>
              {user?.[mapData]?.toFixed(2)}
            </span>
          ) : (
            user?.[mapData]?.toFixed(2) || user?.personalDetails?.[mapData]?.toFixed(2) || ''
          )
        ) : (
          clipText(user?.[mapData], 25) || clipText(user?.personalDetails?.[mapData], 25) || ''
        )
    }
  }
  return (
    <div className='align-items-center'>
      {user.id && mapData && <ImageLightBox ref={lightBoxRef} />}
      {showImageOnly && (
        <div className='symbol symbol-circle swymbol-50px overflow-hidden me-3'>
          <div className='symbol-label'>
            <img
              src={user.icon || user?.processIcon || toAbsoluteUrl(`/media/${user.avatar}`)}
              alt={user.name}
              className='w-100'
            />
          </div>
        </div>
      )}
      {showImage && (
        <div className='symbol symbol-circle swymbol-50px overflow-hidden me-3'>
          <a href='#'>
            {user.avatar ? (
              <div className='symbol-label'>
                <img
                  src={user.icon || toAbsoluteUrl(`/media/${user.avatar}`)}
                  alt={user.name}
                  className='w-100'
                />
              </div>
            ) : (
              <div
                className={clsx(
                  'symbol-label fs-3',
                  `bg-light-${user.initials?.state}`,
                  `text-${user.initials?.state}`
                )}
              >
                {user.initials?.label}
              </div>
            )}
          </a>
        </div>
      )}
      {!showImageOnly && (
        <div className='d-flex flex-column'>
          <a href='#' className='text-gray-800 text-hover-primary mb-1'>
            {returnData()}
          </a>
          {subValue && (
            <div className='d-flex'>
              <span className='badge badge-light-success px-2 py-1' style={{fontSize: '13.9px'}}>
                {accessNestedProperty(user, subValue) || '-'}
              </span>
            </div>
          )}
          {(valueLeft || valueRight) && (
            <div className='d-flex gap-2 mt-1'>
              {valueLeft && (
                <span className='badge badge-light-success px-2 py-1' style={{fontSize: '12px'}}>
                  {accessNestedProperty(user, valueLeft) || '0'}
                </span>
              )}
              {valueRight && (
                <span className='badge badge-light-danger px-2 py-1' style={{fontSize: '12px'}}>
                  {accessNestedProperty(user, valueRight) || '0'}
                </span>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  )
}

function clipText(text, maxLength = 25, clipper = '...') {
  if (!text) return text
  return text.length > maxLength ? text.slice(0, maxLength - clipper.length) + clipper : text
}

export {UserInfoCell}
